import type { CommonTranslations } from "../en/Common";
import type { TranslationShape } from "../../store/types";

export const commonEs: TranslationShape<CommonTranslations> = {
  authVerificationUnavailable: "No se pudo verificar tu sesión. Comprueba la conexión y reintenta.",
  authVerifying: "Verificando tu sesión…",
  authRetryVerification: "Reintentar verificación de sesión",
  reviewSelected: "Revisar selección",
  reviewSelectedCount: "Revisar selección ({{count}})",
  reviewPlanograms: "Revisar planogramas",
  na: "N/A",
  itemSwappedOut: "Artículo intercambiado fuera:",
  itemSwappedIn: "Artículo intercambiado en:",
  facingsChange: "Frentes:",
  swapFacingsModeLabel: "Modo de facings",
  swapFacingsModeMatch: "Coincidir con facings del producto saliente",
  swapFacingsModeFree: "Dejar que DOS balancer decida",
  multiplePlacementFailures: "Múltiples errores de colocación",
  updateReport: {
    skipped: "OMITIDO",
    skipReasons: {
      PRODUCT_NOT_IN_POG: "El producto no está en el planograma de destino",
      ALREADY_AT_TARGET: "Ya se alcanzó el objetivo de frentes",
      ABOVE_EXPANSION_TARGET: "Los frentes actuales ya superan el objetivo de expansión",
      BELOW_REDUCTION_TARGET: "Los frentes actuales ya están por debajo del objetivo de reducción",
      UNKNOWN: "Operación omitida",
    },
    skippedFacings: "Frentes actuales: {{current}} · Objetivo solicitado: {{target}}",
    facingsExpanded: "FRENTES EXPANDIDOS",
    facingsReduced: "FRENTES REDUCIDOS",
    item: "ARTÍCULO",
    items: "ARTÍCULOS",
  },
  search: "Buscar",
  close: "Cerrar",
  cancel: "Cancelar",
  save: "Guardar",
  delete: "Eliminar",
  edit: "Editar",
  view: "Ver",
  back: "Volver",
  next: "Siguiente",
  loading: "Cargando...",
  noResults: "No se encontraron resultados",
  multiSelect: {
    selectedCount: "{{count}} seleccionados",
  },
  pogWarning: {
    rangeRecommendation: "Recomendación de surtido.",
    restrictionNotApplied:
      "No se aplicó la regla: {{rule}}. {{cdtGroup}} también incluye productos que la regla no especifica.",
    relaxedToFinish: {
      label: "Relajado para terminar",
      intro:
        "La solución no pudo terminar cumpliendo todas las reglas, así que el pogger relajó estas, en orden:",
      rung: "{{index}}. {{rung}}: {{rules}}",
      after: "después de que {{error}}",
      rules: {
        placeAllCdt1s: "colocar cada grupo CDT1",
        placeAllVariants: "colocar todas las variantes de producto",
        strictRectangles: "mantener rectangulares los bloques de productos",
        mainSolve: "resolución principal",
        generatedMudmap: "mudmap generado",
        other: "otro detalle de la resolución",
      },
      errors: {
        infeasible: "el solver no pudo encontrar un planograma viable",
        timeout: "el solver se quedó sin tiempo",
        other: "la resolución anterior no pudo completarse",
      },
      rungs: {
        other: "Relajación adicional",
        fallback_place_all: "Espacio para cada CDT1 y variante",
        fallback_variant_fences: "Límites de variantes por estante",
        fallback_block_shapes: "Formas de bloque",
        fallback_mudmap: "Mudmap generado",
        fallback_greedy_fill: "Solución principal (llenado voraz)",
        fallback_cp_model_presolve: "Presolve del solver",
      },
    },
  },
  merchflow: {
    saveFailed: "No se pudo guardar el merchflow",
    editName: "Editar nombre del merchflow",
    editGoLiveDate: "Editar fecha de inicio",
    goLiveDate: "Fecha de inicio",
    deactivationDate: "Fecha de desactivación",
  },
  storePogNotes: {
    button: "Notas",
    title: "Notas del POG de tienda {{id}}",
    field: "Notas",
    noNotes: "Aún no hay notas guardadas",
    lastEdited: "Última edición el {{date}}",
    lastEditedBy: "Última edición por {{name}} el {{date}}",
    loadFailed: "No se pudieron cargar las notas.",
    saveFailed: "No se pudieron guardar las notas del POG",
    discardTitle: "¿Descartar cambios sin guardar?",
    discardDescription:
      "¿Seguro que quieres descartar los cambios? Las notas sin guardar se perderán definitivamente.",
    continueEditing: "Seguir editando",
    discardChanges: "Descartar cambios",
  },
  storePogExport: {
    forceOverwritePdfs: "Forzar sobrescritura de PDF",
    latestVersionNote: "Exporta el planograma más reciente de cada tienda, no la versión mostrada.",
    approvedVersionNote:
      "Exporta el planograma aprobado de cada tienda, sea cual sea la versión aprobada.",
    csvColumns: {
      title: "Elegir columnas CSV",
      rangedItems: "Artículos en surtido",
      unrangedItems: "Artículos fuera del surtido",
      loading: "Cargando columnas...",
      loadFailed: "No se pudieron cargar las columnas CSV. Inténtalo de nuevo.",
      loadFailedToast: "No se pudieron cargar las columnas de exportación CSV",
      retry: "Reintentar",
      search: "Buscar columnas",
      selectedCount: "{{selected}} de {{total}} columnas seleccionadas",
      noMatches: "Ninguna columna coincide con tu búsqueda.",
      export: "Exportar CSV",
    },
  },
  download: "Descargar",
  generate: "Generar",
  status: "Estado",
  category: "Categoría",
  store: "Tienda",
  stores: "Tiendas",
  cluster: "Cluster",
  brand: "Marca",
  critical: "Crítico",
  warning: "Advertencia",
  medium: "Medio",
  low: "Bajo",
  active: "Activo",
  shelves: "Estantes",
  start: "Inicio: {{date}}",
  end: "Fin: {{date}}",
  alerts: "Alertas ({{count}})",
  before: "Antes",
  after: "Después",
  change: "Cambio",
  current: "Actual",
  salesValue: "Valor de Ventas",
  unitsSold: "Unidades Vendidas",
  grossMargin: "Margen Bruto",
  inventoryTurnover: "Rotación de Inventario",
  daysOfInventory: "Días de Inventario",
  outOfStock: "Agotado (%)",
  pareto: "Pareto 80/20",
  premium: "Premium",
  urban: "Urbano",
  suburban: "Suburbano",
  language: "Idioma",
  shelf: "Estante",
  selectedShelves: "Estantes seleccionados",
  selectedShelf: "Estante seleccionado",
  shelvesCount: "{{count}} estantes",
  shelfName: "Estante: {{name}}",
  shelfNotchPrefix: " N:{{notch}}",
  planogramFitCheck: {
    singleStackTitle: "La pila es más alta de lo que permite su estante",
    multipleStacksTitle: "{{count}} pilas son más altas de lo que permiten sus estantes",
    rowFits: "{{item}}: cabe {{count}} fila",
    rowsFit: "{{item}}: caben {{count}} filas",
    more: "y {{count}} más",
  },
  shelfEditor: {
    label: "Editor de estante",
  },
  shelfTypes: {
    label: "Tipo de estante",
    regular: "Regular",
    riser: "Elevador",
    hangCell: "Celda colgante",
    setFailed: "No se pudo establecer el tipo de estante",
  },
  // Vocabulario de peso: el máximo de una repisa es su LÍMITE, nunca su
  // "capacidad" — capacidad ya significa unidades en esta pantalla.
  planogramRules: {
    blocking: {
      summary: "Bloqueo principal: {{mode}}, con {{cdtSource}}.",
      vertical: "vertical",
      horizontal: "horizontal",
      followsStudioOn: "Sigue a CDT Studio: activado, con la versión {{releaseId}}.",
      followsStudioOffRows:
        "Sigue a CDT Studio: desactivado, la versión {{releaseId}} usa bloqueo horizontal en esta pared.",
      followsStudioOffNotFinalized:
        "Sigue a CDT Studio: desactivado hasta que se finalicen los CDT allí.",
      verticalBlockedTitle: "El bloqueo vertical necesita CDT finalizados",
      verticalBlockedText:
        "CDT Studio no se finalizó para este planograma, así que no puede iniciarse una generación vertical.",
      verticalBlockedReason:
        "Finaliza los CDT en CDT Studio o cambia a bloqueo horizontal para generar.",
      stayHorizontal: "Mantener horizontal",
      openStudio: "Abrir CDT Studio",
      finalizeFirstTitle: "Primero finaliza los CDT",
      finalizeFirst:
        "Primero finaliza los CDT: los planogramas de tienda se construyen con las reglas que envía Studio.",
    },
    mudmapWeights: {
      title: "Pesos del mudmap",
      reset: "Restablecer pesos del mudmap",
      resetConfirmTitle: "¿Restablecer los pesos del mudmap?",
      resetConfirmDescription:
        "¿Seguro que quieres restablecer todos los pesos del mudmap a sus valores predeterminados?",
      keepCurrentValues: "Conservar valores actuales",
      resetToDefaults: "Restablecer predeterminados",
    },
    fingerSpace: {
      title: "Espacio para los dedos (pulgadas)",
      description:
        "Hueco que se deja entre la parte superior de los productos y el estante de arriba, en todos los estantes de esta categoría. Solo se relaja en un estante cuando no se puede mantener; la fuerza se ajusta en Espacio para los dedos — relajación, en la pestaña de optimización.",
    },
    snakingCascade: {
      title: "Nivel de cascada del serpenteo",
      description: "Alinea las variantes que abarcan varias bahías mediante serpenteo en cascada",
      off: "Desactivado",
    },
    frontFacings: {
      title: "¿Cuánto preferimos los productos de frente?",
      frontOnly: "Solo productos de frente",
      turnedWhereAllowed:
        "Primero de frente; un paquete puede ir girado donde el producto lo permita",
    },
    fillExtraSpace: {
      title: "¿Podemos llenar espacio extra junto a cajas / bandejas con productos sueltos?",
      description:
        "También activa los remates laterales (unidades giradas de lado junto a los frentes) y los remates superiores (unidades colocadas de lado sobre los frentes) en todos los muebles, además de unidades sueltas junto a las bandejas. Los remates solo se colocan donde queda espacio que un frente completo no puede aprovechar, y nunca en palés.",
      // Flow and simulation updates run frogger, not pogger: caps as before.
      updateDescription:
        "También activa los remates: remates laterales (un paquete girado de lado junto a su bloque) y remates superiores (un paquete tumbado encima de su pila), además de unidades sueltas junto a las bandejas. Los remates solo se colocan donde queda espacio que un frente o una fila completa no puede aprovechar, y nunca en palés.",
    },
    stackToShelfTop: {
      title: "Llenar en alto hasta el estante de arriba",
      description:
        "Añade frentes en alto hasta que cada producto llegue al estante de arriba, no solo a la altura de los productos de al lado.",
    },
    stackPastMaxStack: {
      title: "Ignorar el alto máximo",
      description: "Permite que los frentes en alto superen el alto máximo de cada producto.",
    },
    verticalCapping: {
      title: "Remate superior",
      description:
        "Coloca unidades de lado sobre los frentes, en el espacio que queda bajo el estante de arriba.",
    },
    verticalCappingPastMaxStack: {
      title: "Remate superior por encima del alto máximo",
      description:
        "Remata también los productos con un alto máximo de 1 y los frentes con espacio para otra unidad en alto.",
    },
    slowMovers: {
      title: "¿Dejar fuera del planograma los productos de baja rotación?",
      description:
        "Los productos que venden menos unidades a la semana que el mínimo indicado no se envían al motor de planogramas. Los productos del surtido base y los añadidos a la tienda en los últimos 3 meses siempre se mantienen.",
      threshold: "Unidades mínimas vendidas por semana",
      badge: "Baja rotación",
    },
    optimizationOptions: {
      fingerSpaceTitle: "Espacio para los dedos — relajación",
      fingerSpace:
        "Con qué fuerza se mantiene el hueco de espacio para los dedos fijado en la pestaña General. 0 permite que cualquier estante lo pierda; ∞ nunca. No es el hueco en sí.",
      fixedNotchNum:
        "Peso para mantener cada estante en su nivel (notch) actual. 0 deja que todos los estantes se muevan libremente; ∞ los fija todos. Desactivar el ajuste de niveles de estante en la pestaña General los fija sin importar este control.",
      fixedNotchNumPinned:
        "Fijado en ∞ para esta ejecución: los niveles de estante no se pueden ajustar (General › Fixtures), así que la generación de tiendas ignora este control.",
      cdtOrder:
        "Qué tan estrictamente se aplica el orden del CDT {{level}}. ∞ significa no relajarlo nunca — y cuando el planograma se construye a partir de un mudmap existente que ya rompe el orden del CDT {{level}}, la ejecución se rechaza antes de resolver en lugar de relajarse.",
      prereq:
        "Qué tan estrictamente se aplican los prerrequisitos entre productos. El valor predeterminado es ∞ (nunca se relaja), así que cada ejecución ya lleva una restricción que el solucionador no puede romper.",
      minDistribution:
        "Peso por cada producto obligatorio del surtido principal que queda fuera del planograma. Es un número simple, a diferencia de sus vecinos: aquí no hay ∞, así que 100 es lo más estricto posible. La generación de tiendas envía 10 en lugar de 0.",
    },
    uhd: {
      verticalSplitDescription:
        "Cada división adicional multiplica el límite de tiempo de la ejecución: con 5 divisiones la ejecución dura cinco veces más, y la mitad de ese tiempo se dedica a construir el mudmap.",
      brandBlocks: {
        title: "Las marcas tienen su propio bloque a partir de",
        description:
          "Con el bloqueo vertical, las tiendas con al menos esta cantidad de módulos planifican bloques de marca rectangulares. Los bordes finales pueden variar.",
        descriptionNever:
          "Con el bloqueo vertical, ninguna tienda usa la planificación rectangular de marcas.",
        oneBay: "1 módulo",
        bays: "{{count}} módulos",
        never: "Nunca",
      },
    },
    pallets: {
      title: "Pallets",
      onlyPalletStores: "Solo las tiendas con pallets en el piso usan estas reglas.",
      maxProducts: "Máximo de productos por pallet",
      maxStackHeight: "Altura máxima de apilado (pulg.)",
      maxStackHeightHelp:
        "Con 0, cada pallet se apila hasta la altura de su propio mueble. Un pallet nunca se apila por encima de su mueble.",
    },
    weightRules: {
      tab: "Peso",
      shelfCap: {
        title: "Límite de carga del estante",
        limit: "Carga máxima por estante (gramos)",
        pounds: "{{pounds}} lb",
        noCap: "Sin límite — los estantes se reportan pero no se evalúan",
        limitRequired:
          "Obligatorio mientras esto está activado — ingresa un límite de carga mayor que cero.",
      },
      heavyRule: {
        title: "Los productos pesados van abajo",
        threshold: "Pesado a partir de (gramos)",
        thresholdPounds: "{{pounds}} lb",
        maxDeckY: "Línea de altura",
        maxDeckYHelp:
          "Una coordenada en la misma escala que la geometría de tus muebles, leída del planograma. No son milímetros ni pulgadas — son los mismos números que ya usan tus bahías y estantes.",
        maxDeckYRequired:
          "Obligatorio — no hay un valor predeterminado seguro. Léelo de tus propios muebles; esta regla permanece desactivada hasta que ingreses uno.",
      },
      passes: {
        resolveTitle: "Estantes sobrecargados",
        resolve: "Resolver estantes sobrecargados",
        resolveHelp:
          "Reduce la profundidad en estantes que superan el límite, nunca por debajo del mínimo de suministro; luego elimina el producto con peor valor por peso hasta que el estante cumpla su límite.",
        swapTitle: "Ubicación de marcas pesadas",
        swap: "Bajar marcas pesadas",
        swapHelp:
          "Intercambia bloques completos de marca entre un estante alto y uno bajo para que el producto pesado quede bajo la línea de altura, manteniendo cada marca contigua.",
        swapNeedsHeavyRule:
          'Activa "Los productos pesados van abajo" para darle sus números a esta regla.',
      },
      advanced: {
        title: "Avanzado",
        fillFloor: "Llenado mínimo conservado tras un intercambio",
      },
    },
    dividers: {
      title: "Separadores",
      change: "Cambiar",
      done: "Listo",
      heading: "Productos que llevan separadores o empujadores de resorte",
      explanation:
        "Un estante lleva separadores, o un empujador de resorte, cuando más de la mitad de sus frentes están marcados para ello; entonces cada frente del estante lleva uno.",
      badData:
        "Las medidas de los separadores del planograma base no se pueden usar. Marque los productos que llevan separadores e introduzca un ancho.",
      badDataTitle: "Los datos de separadores del planograma base no se pueden usar.",
      dividerWidth: "Ancho del separador",
      loaderDepth: "Profundidad del empujador de resorte",
      fromBase: "Del planograma base.",
      fromFixtures: "De la página de Mobiliario.",
      fromBoth: "Del planograma base y de la página de Mobiliario.",
      tickCounts:
        "Separadores: {{dividers}} de {{total}} · Empujadores de resorte: {{loaders}} de {{total}}",
      resetToBase: "Restablecer al planograma base",
      clearAll: "Desmarcar todo",
      groupBy: "Agrupar por",
      searchProducts: "Buscar productos",
      columnDividers: "Separadores",
      columnLoaders: "Empujador",
      products: "Productos",
      noGroup: "Sin grupo",
      showGroup: "Mostrar {{name}}",
      hideGroup: "Ocultar {{name}}",
      groupCounts: "{{counts}} de {{total}}",
      loadingProducts: "Cargando productos…",
      noProducts: "Sin productos",
      onBase: "En el planograma base",
      readingBase: "Leyendo el planograma base…",
      noShelves: "No hay estantes en el planograma base",
      keepFixture: "Conservar los separadores que ya tiene el mobiliario de la tienda.",
      ends: "Extremos del estante",
      atStart: "Separador en el extremo izquierdo",
      atEnd: "Separador en el extremo derecho",
      loaderMode: "Empujadores de resorte",
      loaderModes: {
        products: "Seguir los productos",
        shelf: "Quedarse con el estante",
      },
      shelfModeNote: "Las marcas solo indican qué productos necesitan uno.",
      explanationShelfMode:
        "Un estante lleva separadores cuando más de la mitad de sus frentes están marcados para ellos; los empujadores de resorte se quedan donde está el herraje del estante.",
      shelfHardwareDecides: "(decide el herraje del estante)",
      errors: {
        widthMissing: "Introduzca el ancho del separador (el grosor de un separador).",
        loaderDepthMissing: "Introduzca la profundidad del empujador de resorte.",
        loaderDepthNegative: "Introduzca 0 o más.",
        loaderDepthNotBelowShelf: "Debe ser menor que la profundidad del estante ({{depth}}).",
        loaderDepthNotBelowShallowestShelf:
          "Debe ser menor que el estante menos profundo ({{depth}}).",
        ruleInvalid: "No se pudo leer la regla de separadores.",
      },
      oSummary: "Resumen de O",
      level: "Nivel {{level}}",
      o: {
        reading: "O está leyendo el planograma base…",
        noBase: "O no pudo leer el planograma base, así que no hay separadores.{{keep}}",
        badBaseOneFault:
          "En el planograma base, {{faults}} (un error de importación), así que O no puso separadores.{{keep}}",
        badBaseFaults:
          "En el planograma base, {{faults}} (errores de importación), así que O no puso separadores.{{keep}}",
        faultWidth: "el ancho del separador es igual al ancho del estante en {{shelves}}",
        faultFlags:
          "los indicadores de inicio y fin del separador son mayores que 1 en {{shelves}}",
        faultsJoin: "{{first}} y {{second}}",
        oneShelf: "{{count}} estante",
        shelves: "{{count}} estantes",
        noneInBase: "No hay separadores en el planograma base, así que aquí tampoco.{{keep}}",
        noneOnAnyShelf: "No hay separadores en ningún estante.",
        noneNeededNoFixtures:
          "Ningún producto necesita separadores. O no puede ver el mobiliario de esta tienda, así que no se conserva ninguno.",
        noneNeededKept:
          "Ningún producto necesita separadores. {{kept}} de {{total}} estantes conservan los separadores que ya tiene su mobiliario.",
        noneNeededKeptWithWidth:
          "Ningún producto necesita separadores. {{kept}} de {{total}} estantes conservan los separadores que ya tiene su mobiliario, {{width}}.",
        noWidthYet: "Separadores para {{products}}, pero aún sin ancho.{{keep}}",
        likeBase:
          "O puso separadores como en el planograma base: {{products}}, {{shelves}}, {{width}}.{{keep}}",
        forProducts: "Separadores para {{products}}, en {{shelves}}, {{width}}.{{keep}}",
        keepClause: " Los estantes cuyo mobiliario ya tiene separadores los conservan.",
        productCount: "{{count}} de {{total}} productos",
        shelfCount: "{{count}} de {{total}} estantes",
        width: "{{width}} de ancho",
      },
      loaderO: {
        noneInBase: "No hay empujadores de resorte en el planograma base, así que aquí tampoco.",
        none: "No hay empujadores de resorte.",
        likeBaseDepthNotSet:
          "O puso empujadores de resorte como en el planograma base: {{products}}, {{shelves}}; sin profundidad definida en {{count}} de ellos.",
        likeBase:
          "O puso empujadores de resorte como en el planograma base: {{products}}, {{shelves}}.",
        likeBaseWithDepth:
          "O puso empujadores de resorte como en el planograma base: {{products}}, {{shelves}}, {{depth}}.",
        noDepthYet: "Empujadores de resorte para {{products}}, pero aún sin profundidad.",
        forProducts: "Empujadores de resorte para {{products}}, en {{shelves}}.",
        forProductsWithDepth:
          "Empujadores de resorte para {{products}}, en {{shelves}}, {{depth}}.",
        depth: "{{depth}} de profundidad",
        depthRange: "de {{low}} a {{high}} de profundidad",
        shelfModeNone:
          "No hay empujadores de resorte en los estantes del planograma base, así que aquí tampoco.",
        shelfModeBase: "Los empujadores de resorte se quedan en {{shelves}} del planograma base.",
        shelfModeBaseWithDepth:
          "Los empujadores de resorte se quedan en {{shelves}} del planograma base, {{depth}}.",
        shelfModeSome: "Los empujadores de resorte se quedan en {{kept}} de {{total}} estantes.",
        shelfModeSomeWithDepth:
          "Los empujadores de resorte se quedan en {{kept}} de {{total}} estantes, {{depth}}.",
      },
      result: {
        name: "Módulo {{bay}} Estante {{shelf}}",
        dividers: "separadores",
        noDividers: "sin separadores",
        facings: "{{needing}} de {{facings}} frentes",
        needsMoreThanHalf: "{{needing}} de {{facings}} frentes (se necesita más de la mitad)",
        count: "{{needing}} de {{facings}}",
        countNeedsMoreThanHalf: "{{needing}} de {{facings}} (se necesita más de la mitad)",
        setAlways: "fijado en siempre para esta tienda",
        setNever: "fijado en nunca para esta tienda",
        keptFromFixture: "conservado del mobiliario de la tienda",
        total: "{{count}} de {{total}} estantes llevan separadores.",
        totalWithLoaders:
          "{{count}} de {{total}} estantes llevan separadores; {{loaders}} llevan empujadores de resorte.",
        noLoader: "sin empujador",
        loader: "empujador {{depth}}",
        loaderOfShelf: "empujador {{depth}} (estante)",
      },
    },

    tellO: {
      copy: {
        apply: "Aplicar",
        notThat: "Eso no",
        doThat: "Hacer eso",
        neverMind: "No importa",
        undo: "Deshacer",
        undone: "De vuelta a lo predeterminado de O.",
        dividers: "Separadores",
        loaders: "Empujadores de resorte",
        both: "Ambos",
        neither: "Ninguno",
        give: "Añadir",
        takeAway: "Quitar",
        useDepth: "Usar {{depth}}",
        product: "producto",
        products: "productos",
        shelf: "estante",
        shelves: "estantes",
        bay: "bahía",
        bays: "bahías",
        level: "Nivel {{level}}",
        positionTop: "el estante superior",
        positionTopMany: "estantes superiores",
        positionBottom: "el estante inferior",
        positionBottomMany: "estantes inferiores",
        positionNumber: "el estante {{position}}",
        groupTop: "los estantes superiores del planograma base",
        groupBottom: "los estantes inferiores del planograma base",
        groupNumber: "el estante {{position}} del planograma base",
        wide: ", {{value}} de ancho",
        deep: ", {{value}} de profundidad",
        range: "{{low}} a {{high}}",
        productCount: "{{count}} de {{total}} productos",
        shelfCount: "{{count}} de {{total}} estantes",
        counts: "{{products}}, {{shelves}}",
        shortCounts: "{{count}} de {{total}}, {{shelves}}",
        previewGet:
          "{{dividers}} de {{total}} estantes llevan separadores; {{loaders}} llevan empujadores de resorte.",
        previewKeep:
          "{{dividers}} de {{total}} estantes llevan separadores; {{loaders}} conservan los empujadores de resorte.",
        bothOnly: "Solo {{group}} llevan separadores y empujadores de resorte",
        bothAll: "Separadores y empujadores de resorte para todos los productos",
        bothExcept: "Separadores y empujadores de resorte para todos excepto {{group}}",
        bothAdd: "Separadores y empujadores de resorte también para {{group}}",
        dividersOnly: "Solo {{group}} llevan separadores",
        dividersAll: "Separadores para todos los productos",
        dividersExcept: "Separadores para todos excepto {{group}}",
        dividersAdd: "Separadores también para {{group}}",
        loadersOnly: "Empujadores de resorte solo para {{group}}",
        loadersAll: "Empujadores de resorte para todos los productos",
        loadersExcept: "Empujadores de resorte para todos excepto {{group}}",
        loadersAdd: "Empujadores de resorte también para {{group}}",
        bothProductCounts:
          "{{dividers}} de {{total}} productos llevan separadores, {{loaders}} llevan empujadores de resorte",
        bothChange:
          "{{lead}}: {{products}}; {{dividers}} de {{total}} estantes llevan separadores, {{loaders}} llevan empujadores.",
        dividerChange: "{{lead}}: {{counts}}{{width}}. Los empujadores de resorte no cambian.",
        loaderChange: "{{lead}}: {{counts}}{{depth}}. Los separadores no cambian.",
        likeBase: "Separadores como en el planograma base",
        noDividers: "Sin separadores",
        noLoaders: "Sin empujadores de resorte",
        clearDividersEmpty:
          "Sin separadores en ningún estante. Los empujadores de resorte no cambian.",
        clearDividers:
          "Sin separadores en ningún estante. Los empujadores de resorte se quedan como están: {{counts}}{{depth}}.",
        clearLoadersEmpty: "Sin empujadores de resorte. Los separadores no cambian.",
        clearLoaders:
          "Sin empujadores de resorte. Los separadores se quedan como están: {{counts}}{{width}}.",
        instead: " en lugar de {{previous}}",
        widthChange:
          "Separadores de {{width}} de ancho{{instead}}, los mismos productos: {{counts}}.",
        depthChange:
          "Empujadores de resorte de {{depth}} de profundidad{{instead}}, los mismos productos: {{counts}}.",
        fewerFacings:
          "{{head}} Los separadores más anchos reducen los frentes: unos {{difference}} menos por estante de {{width}} {{unit}}.",
        moreFacings:
          "{{head}} Los separadores más estrechos liberan frentes: unos {{difference}} más por estante de {{width}} {{unit}}.",
        keepOn:
          "Igual que ahora, y los estantes cuyo mobiliario ya tiene separadores los conservan, incluso donde ningún producto necesita uno.",
        keepOff:
          "Los estantes cuyo mobiliario tiene separadores ya no los conservan; deciden los productos.",
        loaderProducts:
          "Los empujadores de resorte vuelven a seguir a los productos: {{counts}}{{depth}}.",
        loaderShelvesEmpty:
          "No hay empujadores de resorte en los estantes del planograma base, así que aquí tampoco. Los separadores no cambian.",
        loaderShelves:
          "Los empujadores de resorte se quedan en {{count}} {{shelves}} del planograma base{{depth}}, independientemente de lo que necesiten los productos. Los separadores no cambian.",
        shelfWhere: "Bahía {{bayNo}} Estante {{shelfNo}} de la tienda {{storeCode}}{{base}}",
        baseStore: " (la tienda del planograma base)",
        shelfDividerRule:
          "{{where}} vuelve a seguir la regla de separadores. Los demás estantes no cambian.",
        shelfDividerNever:
          "{{where}} no lleva separadores, independientemente de la regla. Los demás estantes no cambian.",
        shelfDividerAlways:
          "{{where}} siempre lleva separadores, independientemente de la regla. Los demás estantes no cambian.",
        shelfLoaderRule:
          "{{where}} vuelve a seguir la regla de empujadores de resorte. Los demás estantes no cambian.",
        shelfLoaderNone:
          "{{where}} no lleva empujador de resorte, independientemente de los productos. Los demás estantes no cambian.",
        shelfLoaderDepth:
          "{{where}} lleva un empujador de resorte de {{depth}}, independientemente de los productos. Los demás estantes no cambian.",
        saved:
          "Guardado para Bahía {{bayNo}} Estante {{shelfNo}} de la tienda {{storeCode}}. Vuelve a generar la tienda para ajustar los productos.",
        shelfUndone: "Bahía {{bayNo}} Estante {{shelfNo}} vuelve a seguir la regla.",
        cannotPosition:
          "{{feature}} siguen a los productos, no a las posiciones de los estantes, así que O no puede elegir {{position}} en todas las tiendas.",
        nearestPosition:
          "{{head}} Lo más parecido: {{feature}} para {{count}} {{products}} que están en {{position}} del planograma base.",
        sits: "está",
        sit: "están",
        oneStore: "Los ajustes manuales de un estante se hacen para una tienda a la vez.",
        nearestStore:
          "Los ajustes manuales de un estante se hacen para una tienda a la vez. Lo más parecido: Bahía {{bayNo}} Estante {{shelfNo}} de la tienda {{storeCode}}.",
        unknownProducts:
          "O no encuentra '{{phrase}}' entre los productos o grupos de esta categoría.",
        notUnderstood: "O no entendió eso. Prueba una de estas opciones o abre Ajustes avanzados.",
        bothModes:
          "Los empujadores de resorte siguen a los productos o se quedan con el estante; no pueden hacer ambas cosas.",
        shelfNotFound:
          "No existe Bahía {{bayNo}} Estante {{shelfNo}} en el planograma base ({{bays}} {{bayWord}}, hasta {{shelves}} {{shelfWord}}).",
        depthTooDeep:
          "Los empujadores de resorte no pueden tener {{depth}} de profundidad: el estante menos profundo mide {{shallowest}}. La mayor profundidad que cabe es {{deepest}}.",
        readingGroup:
          "Interpreté '{{phrase}}' como {{value}} ({{detail}}), {{count}} {{products}}.",
        readingName: "Interpreté '{{phrase}}' como {{count}} {{products}} con el nombre {{word}}.",
        readingProduct: "Interpreté '{{phrase}}' como {{product}}.",
        questionFeaturePhrase: "¿Para qué quieres {{phrase}} ({{label}}, {{count}} {{products}})?",
        questionFeature: "¿Para qué quieres {{label}} ({{count}} {{products}})?",
        questionWhich: "¿A cuál te refieres con '{{phrase}}'?",
        questionInOut: "'{{phrase}}': ¿añadir {{feature}} o quitarlos?",
        questionShelf:
          "Bahía {{bayNo}} Estante {{shelfNo}} se ajusta de uno en uno: ¿separadores o empujadores de resorte primero?",
        groupOption: "{{label}} ({{count}})",
        chipKeep: "Conservar el herraje de la tienda",
        chipDoNotKeep: "No conservar el herraje de la tienda",
        chipLoaderProducts: "Los empujadores siguen a los productos",
        chipLoaderShelf: "Los empujadores se quedan con el estante",
        prefillWidth: "Separadores {{number}} {{unit}} de ancho",
        prefillDepth:
          "Empujadores de resorte {{number}} {{unit}} de profundidad para todos los productos",
      },
      link: "Decirle a O",
      placeholder: "Dile a O qué cambiar…",
      send: "Enviar",
      freeTextDisabledInBaseMode:
        "Las solicitudes de texto libre no están disponibles al editar el planograma base. Usa una sugerencia o abre Mostrar detalles.",
      thinking: "O está leyendo eso…",
      offline:
        "O no puede leer texto libre ahora mismo. Toca una sugerencia o abre Mostrar detalles.",
      failed: "O no pudo responder a eso. Inténtalo más tarde o toca una sugerencia.",
      notUnderstood: "O no entendió eso. Prueba una de estas opciones o abre Ajustes avanzados.",
      otherStore: "Aquí O solo puede cambiar estantes de la tienda {{storeCode}}.",
      otherStoreUnknown: "Aquí O solo puede cambiar estantes de la tienda de este planograma.",
      undo: "Deshacer",
      backToDefault: "Volver a lo predeterminado de O",
      backToDefaultDone: "De vuelta a lo predeterminado de O.",
      showDetails: "Mostrar detalles",
      hideDetails: "Ocultar detalles",
      notSaved: "No se guardó. Inténtalo de nuevo.",
    },
    cdtSource: {
      sectionTitle: "Árbol de Decisión del Cliente",
      question: "¿Qué CDT deben seguir estos planogramas?",
      storeProduct: {
        label: "CDT del feed de datos",
        description:
          "Usa el CDT que llegó con cada producto en tu último feed de datos. Los productos que llegaron sin uno toman el CDT de la tienda. No se aplica ninguna versión de CDT Studio, así que se omiten las restricciones que agregó CDT Studio; las restricciones que configuraste tú siguen aplicándose.",
        updateDescription:
          "Usa el CDT que llegó con cada producto en tu último feed de datos. Los productos que llegaron sin uno toman el CDT de la tienda.",
      },
      categoryTree: {
        label: "CDT principal / fijado",
        description:
          "Cada tienda usa la versión fijada para ella. Las tiendas sin una versión fijada usan la versión de CDT Studio de este planograma, o el CDT principal si no hay una versión de Studio.",
      },
      pogSnapshot: {
        label: "Tal como está en este planograma",
        description:
          "Conserva el árbol CDT con el que se generó este planograma. Si después esta tienda pasa a otro árbol, se ignora, pero los cambios hechos dentro de ese mismo árbol sí se aplican.",
      },
      pinnedStores_one: "{{count}} tienda fijada",
      pinnedStores_other: "{{count}} tiendas fijadas",
      pinnedVersion_one: "{{count}} tienda fijada a {{version}}",
      pinnedVersion_other: "{{count}} tiendas fijadas a {{version}}",
      onRelease_one: "{{count}} tienda en la versión de Studio",
      onRelease_other: "{{count}} tiendas en la versión de Studio",
      onPrimary_one: "{{count}} tienda en el CDT principal{{version}}",
      onPrimary_other: "{{count}} tiendas en el CDT principal{{version}}",
      defaultedToCategoryTree:
        "Se eligió CDT principal / fijado porque este planograma tiene una versión de CDT Studio.",
      defaultedToStoreProduct:
        "Se eligió CDT del feed de datos porque este planograma aún no tiene una versión de CDT Studio.",
      defaultedToCategoryTreeFromVersion:
        "Se eligió CDT principal / fijado porque este flujo se inició desde una versión de CDT. Cada tienda usa la versión fijada o el CDT principal.",
    },
  },
  shelfDividers: {
    why: {
      setAlways: "Fijado en siempre para esta tienda.",
      keptFromFixture: "Conservado del mobiliario de la tienda.",
      setNever: "Fijado en nunca para esta tienda.",
      setNeverWithCounts:
        "Fijado en nunca para esta tienda. {{needing}} de {{facings}} frentes necesitan separadores.",
      notNeeded: "Ningún producto aquí necesita separadores",
      needed: "{{needing}} de {{facings}} frentes necesitan separadores",
      neededWithNotes: "{{needing}} de {{facings}} frentes necesitan separadores ({{notes}})",
      needsMoreThanHalf: "se necesita más de la mitad",
      valueIs: "{{label}} es {{value}}",
      noValue: "Sin {{label}}",
    },
    rows: {
      dividers: "Separadores",
      none: "Ninguno",
      betweenEveryFacing: "Entre cada frente",
      count: "{{count}} separadores",
      width: "Ancho del separador",
      ends: "Extremos del separador",
      space: "Espacio de separadores",
      why: "Por qué",
    },
    ends: {
      both: "Ambos extremos",
      start: "Solo izquierdo",
      end: "Solo derecho",
      neither: "Ninguno",
    },
    override: {
      title: "Este estante en esta tienda",
      follow: "Seguir la regla",
      always: "Siempre separadores",
      never: "Nunca separadores",
      saved:
        "Guardado para Módulo {{bay}} Estante {{shelf}} en esta tienda. Vuelva a generar la tienda para reajustar los productos.",
      notSaved: "No se guardó. Inténtelo de nuevo.",
      saveFailed: "No se pudo guardar la configuración de separadores del estante",
    },
    columns: {
      width: "Ancho del separador",
      height: "Alto del separador",
      depth: "Profundidad del separador",
      atStart: "Separador al inicio",
      atEnd: "Separador al final",
      betweenFacings: "Separadores entre frentes",
      thisShelf: "Separadores (este estante)",
    },
  },
  frontOverhang: {
    fixBeforeApproval: "Corrige el voladizo de los estantes antes de aprobar o exportar.",
    violation:
      "{{product}} en el estante {{shelf}} necesita {{excess}} pulgadas de voladizo frontal. El estante permite {{allowance}} pulgadas; solo se permite un paquete UNIT de fondo en un estante regular, nivelado y sin fusionar, dentro del 20% de su profundidad orientada.",
    violationFallback:
      "El producto {{product}} en el estante {{shelf}} requiere corregir el voladizo frontal antes de aprobar o exportar.",
    needsCorrection: "El voladizo frontal necesita corrección",
    shelfDetailsLabel: "Voladizo frontal",
    editShelf: {
      label: "Voladizo frontal máx.:",
      help: "Usa la misma unidad de longitud que la profundidad del estante. Permite un solo paquete sobredimensionado de fondo, con un límite del 20% de su profundidad en la orientación elegida. Cero desactiva el voladizo en este planograma. Los planogramas de tienda también requieren permiso en el estante de la tienda en Mobiliario. Cambiar este valor no cambia ese permiso del estante físico. Solo son elegibles los estantes regulares, nivelados y sin fusionar.",
    },
    marker: {
      shelfAllowed: "Voladizo permitido",
      shelfCheck: "Revisar voladizo",
      shelfDescription:
        "Voladizo permitido del estante: {{allowance}}. Cada producto debe quedar dentro del 20% de su profundidad en la orientación elegida, con un solo paquete UNIT de fondo.",
      shelfDescriptionIneligible:
        "Voladizo permitido del estante: {{allowance}}. Cada producto debe quedar dentro del 20% de su profundidad en la orientación elegida, con un solo paquete UNIT de fondo. Este estante no es elegible.",
      itemDescriptionValid:
        "Voladizo frontal: {{excess}} ({{percent}}% de la profundidad orientada). Profundidad del producto: {{depth}}; profundidad útil del estante: {{support}}. Dentro de los límites del planograma.",
      itemDescriptionInvalid:
        "Voladizo frontal: {{excess}} ({{percent}}% de la profundidad orientada). Profundidad del producto: {{depth}}; profundidad útil del estante: {{support}}. Debe corregirse antes de aprobar o exportar.",
    },
    legend: {
      label: "Leyenda de voladizo frontal",
      shelfAllowed: "Borde del estante: voladizo permitido",
      shelfCheck: "Borde del estante: revisar voladizo",
      product: "Borde y parte inferior del producto: {{label}}",
      productInvalid: "Borde y parte inferior del producto: {{label}} (debe corregirse)",
      severalProducts: "voladizo frontal",
    },
    fixtures: {
      header: "Voladizo frontal máx.",
      headerWithUnit: "Voladizo frontal máx. ({{unit}})",
      storeHeader: "Tienda",
      categoryIdHeader: "ID de categoría",
      storeCode: "Código de tienda",
      allStores: "Todas las tiendas",
      filter: "Filtrar",
      note: "Los permisos de voladizo se aplican a este estante de la tienda en las próximas ejecuciones. Cero desactiva el voladizo.",
      help: "Permiso del estante físico, en la misma unidad que la profundidad del estante. Cero lo desactiva. Los productos pueden sobresalir como máximo el 20% de su profundidad en la orientación elegida, con un solo paquete de fondo.",
      invalidLength: "Introduce cero o una longitud positiva con dos decimales como máximo.",
      ineligible:
        "El voladizo frontal requiere un estante regular nivelado con profundidad positiva.",
      notConfirmed:
        "El servidor no confirmó este permiso del estante. Recarga e inténtalo de nuevo.",
      notSaved: "No se guardó el permiso de voladizo. Inténtalo de nuevo.",
    },
  },
  shelfLoader: {
    why: {
      needed: "{{needing}} de {{facings}} frentes necesitan un empujador de resorte",
      neededTypicalDepth:
        "{{needing}} de {{facings}} frentes necesitan un empujador de resorte: {{depth}}, como los estantes con empujador del planograma base",
      needsMoreThanHalf:
        "{{needing}} de {{facings}} frentes necesitan un empujador de resorte (se necesita más de la mitad)",
      neededWithoutLoader:
        "{{needing}} de {{facings}} frentes necesitan un empujador de resorte; este estante no tiene empujador",
      notNeeded: "Ningún producto aquí necesita un empujador de resorte",
      loaderWithoutNeed:
        "Ningún producto aquí necesita un empujador de resorte; el estante tiene uno",
      setNoneOnFixturesPage:
        "Fijado en ninguno en la página de Mobiliario para esta tienda. {{needing}} de {{facings}} frentes necesitan uno.",
      setOnFixturesPage: "Fijado en {{depth}} en la página de Mobiliario para esta tienda.",
      depthNotSet:
        "{{needing}} de {{facings}} frentes necesitan un empujador de resorte; profundidad no definida",
      onBaseShelf:
        "Se queda con el estante: el estante del planograma base tiene un empujador de resorte de {{depth}}. {{needing}} de {{facings}} frentes necesitan uno.",
      notOnBaseShelf:
        "Se queda con el estante: el estante del planograma base no tiene empujador de resorte. {{needing}} de {{facings}} frentes necesitan uno.",
    },
    rows: {
      label: "Empujador de resorte",
      depth: "{{depth}} (voladizo trasero -{{depth}})",
      depthOnFixturesPage:
        "{{depth}} (voladizo trasero -{{depth}}), fijado en la página de Mobiliario",
      usableDepth: "Profundidad utilizable",
      none: "Ninguno",
      noneOnFixturesPage: "Ninguno, fijado en la página de Mobiliario",
    },
    fixtures: {
      header: "Profundidad del empujador de resorte",
      headerWithUnit: "Profundidad del empujador de resorte ({{unit}})",
      tooltip:
        "Profundidad que ocupa el empujador de resorte detrás de los productos en este estante. Vacío: seguir la regla del empujador de resorte. 0: sin empujador.",
      backOverhang: "Guardado en un PSA como voladizo trasero -{{depth}}",
      notSet: "Sin definir",
      none: "Ninguno",
      notSaved: "No se guardó. Inténtelo de nuevo.",
    },
  },
  shelfWeight: {
    label: "Peso",
    load: "{{pounds}} lb",
    // Procedencia: un peso declarado y uno estimado no deben leerse igual.
    loadWithNotes: "{{pounds}} lb ({{notes}})",
    measured: "medido",
    allDerived: "estimado",
    someDerived: "{{count}} estimados",
    unweighed: "{{count}} sin pesar",
    bulk: "VOLUMINOSO",
    overloadedLabel: "Sobrecargado",
    overloadedRequestDefault: "supera el límite de {{pounds}} lb fijado para esta ejecución",
    overloadedFixture: "supera el límite del mueble de {{pounds}} lb",
    limitLabel: "Límite de peso",
    noLimit: "sin límite de peso fijado para esta ejecución",
    pogTotal: "Peso total",
  },
  widthFormatted: "{{value}} m {{cm}} cm",
  preparedBy: "Preparado Por",
  approvedBy: "Aprobado Por",
  categoryOwner: "Propietario de Categoría",
  dateEffective: "Fecha de Vigencia",
  segment: "Segmento",
  page: "Página",
  newItemSummary: "Resumen de Artículos Nuevos",
  deletedItemSummary: "Resumen de Artículos Eliminados",
  shelfSemanticReport: "Reporte Semántico de Estantería",
  width: "Ancho",
  depth: "Profundidad",
  height: "Alto",
  highlights: {
    defaultInsertedItemName: "Nuevo artículo insertado",
    newItemBadge: "PI",
    itemWeight: "Peso del artículo",
    itemWeightSublabel: "lb en el estante",
    shelfWeight: "Peso del estante",
    shelfWeightSublabel: "lb en la tabla",
    shelfWeightPct: "% del peso del estante",
    shelfWeightPctSublabel: "del límite",
    overloaded: "Sobrecargado",
    overloadedSublabel: "sobre el límite",
  },
  planogramCanvas: {
    rendererToggle: "Renderizador de lienzo",
    showDividersToggle: "Mostrar separadores",
    itemCount: "{{count}} artículos",
    invalidProductDimensions:
      "Este producto no se puede agregar porque sus dimensiones no son válidas.",
    newItemIndicator: "Indicador de artículo nuevo",
    moveFeedback: {
      alreadyAtPosition: "Ese producto ya está en esa posición.",
      missingTarget: "Suelte sobre un producto o sobre el espacio encima de un estante.",
      incompatibleTarget: "Este producto no se puede colocar en ese mobiliario.",
      priorityOrder: "Ese movimiento rompería el orden de productos. Elija otra posición.",
      collision: "No hay suficiente espacio libre en esa posición.",
      fallback: "No se pudo realizar este movimiento. Pruebe con otro producto o estante.",
    },
    aisleBreak: {
      breakHere: "Cortar el pasillo aquí",
      breakBetween: "Cortar el pasillo entre las bahías {{leftBayNo}} y {{rightBayNo}}",
      joinBays: "Unir las bahías {{leftBayNo}} y {{rightBayNo}}",
      setBy: "Corte de pasillo. Puesto por {{name}} el {{date}}.",
      setInEditor: "Corte de pasillo. Puesto en el editor.",
      fromFixtureFile: "Corte de pasillo. Del archivo de mobiliario.",
    },
    itemMenu: {
      delete: "Eliminar",
      duplicate: "Duplicar",
      flipHorizontally: "Voltear horizontalmente",
      sideView: "Vista lateral",
      unrange: "Quitar del surtido",
    },
    bayMenu: {
      addBayLeft: "Agregar bahía a la izquierda",
      addBayRight: "Agregar bahía a la derecha",
      deleteBay: "Eliminar bahía",
      newShelf: "Estante nuevo",
      title: "Bahía {{bayNo}}",
      baysKeptByAisleBreak:
        "Este tramo tiene un corte de pasillo: sus bahías solo cambian en el mobiliario de la tienda.",
    },
    containerMenu: {
      delete: "Eliminar",
      splitBottom: "Dividir hacia abajo",
      splitRight: "Dividir a la derecha",
      unrange: "Quitar del surtido",
    },
    shelfMenu: {
      delete: "Eliminar",
      duplicate: "Duplicar",
      flipHorizontally: "Voltear horizontalmente",
      mergeLeft: "Combinar a la izquierda",
      mergeRight: "Combinar a la derecha",
      moveDown: "Mover hacia abajo",
      moveUp: "Mover hacia arriba",
      sortCdt1: "Ordenar por prioridad CDT1",
      sortCdt2: "Ordenar por prioridad CDT2",
      sortCdt3: "Ordenar por prioridad CDT3",
      unmergeLeft: "Separar a la izquierda",
      unmergeRight: "Separar a la derecha",
      viewUnranged: "Ver productos fuera del surtido",
    },
  },
  metricFilter: {
    label: "Mostrar tiendas con puntuación por debajo de",
    anyScore: "Cualquier puntuación",
    thresholdTitle: "Puntuación",
    thresholdPlaceholder: "0-100",
    apply: "Aplicar",
    clear: "Quitar",
    notScored: "Sin puntuar",
    exportAllUnavailable: "Quita el filtro de puntuación para exportar todas las tiendas.",
  },
  planogramMetrics: {
    returnOnSpace: {
      title: "Retorno del espacio",
      description:
        "Indica si cada parte de la categoría recibe espacio de estante acorde con sus ventas. Una puntuación alta significa que ningún grupo tiene espacio insuficiente; asignar a un grupo más espacio del que genera no reduce la puntuación.",
    },
    coreRange: {
      title: "Surtido principal",
      description:
        "Indica cuántos productos imprescindibles llegaron realmente al estante. Los frentes adicionales del mismo producto cuentan una sola vez.",
      emptyReason:
        "Ningún producto de este planograma está marcado como surtido principal, por lo que no hay nada que medir.",
    },
    shelfAlignment: {
      title: "Alineación de estantes",
      description:
        "Indica si los estantes quedan a la misma altura a lo largo del mueble, de bahía a bahía. Los estantes cercanos pero desnivelados cuentan como error.",
    },
    dosMos: {
      title: "DOS / MOS",
      description:
        "Indica cuántos productos mantienen suficiente inventario en el estante para seguir vendiéndose entre entregas. Un producto reduce la puntuación si no alcanza su objetivo de días de suministro o de unidades en estante.",
    },
    aesthetics: {
      title: "Estética",
      description:
        "Indica lo ordenado y comprable que parece el planograma: bloques limpios, el orden propio de la categoría, estantes llenos y los paquetes pesados abajo. No dice nada sobre las ventas, así que léalo junto con las cifras que sí lo hacen.",
      breakdown: "De qué se compone la puntuación",
      reasonsTitle: "Principales motivos de puntos perdidos",
      gatesTitle: "Comprobaciones que este planograma no supera",
      notGraded: "nada que medir",
      blockingParts: {
        shape: "forma",
        edges: "bordes rectos",
        columns: "bloqueo vertical",
        bands: "bloqueo horizontal",
      },
      gradedAgainstRelease: "Puntuación {{version}}, evaluada con la versión {{release}} del CDT",
      gradedAgainstColumns:
        "Puntuación {{version}}, evaluada con el bloqueo vertical del propio planograma",
      gradedAgainstOwnHorizontal:
        "Puntuación {{version}}, evaluada con el bloqueo horizontal del propio planograma",
      releaseUnavailable:
        "Sin puntuación: no se pudo cargar la versión del CDT con la que se generó este planograma. Actualiza la página para intentarlo de nuevo.",
      requestUnavailable:
        "Sin puntuación: no se pudo cargar la solicitud con la que se generó este planograma. Actualiza la página para intentarlo de nuevo.",
      bandSource: {
        draft: "Reglas de estante: las bandas aceptadas del borrador",
        request: "Reglas de estante: las restricciones enviadas a la generación de este plan",
        emission: "Reglas de estante: las reglas CDT emitidas para la generación de esta tienda",
        legacyFences:
          "Reglas de estante: cercas heredadas guardadas en el plan, no las restricciones de la generación",
      },
      coreRangeSource: {
        request: "Productos obligatorios: la gama básica enviada a la generación de este plan",
        pogFlag: "Productos obligatorios: los productos que el plan marca como gama básica",
      },
      points: "−{{points}}",
      parts: {
        blocking: "Bloques",
        cdt: "Orden de la categoría",
        fullness: "Estantes llenos",
        rulesKept: "Reglas de estante",
        ergonomics: "Sentido de estante",
        range: "Surtido conservado",
      },
      reasons: {
        blockingPair: "{{first}} y {{second}} tienen bloques poco estéticos",
        blockingOne: "{{first}} tiene bloques poco estéticos",
        blockingPlain: "Algunos productos no se mantienen juntos en un solo bloque",
        ruleFence: "{{product}} está en el estante {{shelf}}, donde no se permite {{band}}",
        ruleMissing: "Falta {{band}} en el estante {{shelf}}",
        rulePlain: "El planograma no respeta las reglas de estante",
        gap: "El estante {{shelf}} tiene un hueco de {{gap}} {{unit}}",
        fullnessPlain: "Los estantes no están llenos",
        brandDropped: "{{brand}} no está en el planograma",
        unplaced: "{{count}} productos no están en el planograma",
        sizeOrder: "Los tamaños no van de menor a mayor en {{block}}",
        orderPlain: "{{block}} no sigue el orden de la categoría",
        cdtPlain: "El planograma no sigue el orden de la categoría",
        heavyHigh: "Los paquetes pesados no están en los estantes bajos",
        bigOverSmall: "Los paquetes grandes están por encima de los pequeños",
      },
      gates: {
        overlap: "Hay productos montados unos sobre otros",
        "past-edge": "Hay productos que sobresalen del estante",
        "empty-shelf": "Hay un estante vacío",
        unplaced: "No todos los productos están en el planograma",
        "brand-eliminated": "Se ha eliminado una marca",
        "block-in-pieces": "Una marca está partida en más de un bloque",
        "block-staircased": "Una columna de primer nivel tiene bordes irregulares",
        "block-out-of-shape": "Un bloque de marca no llena su rectángulo",
        "band-broken": "Hay un producto en un estante que su banda no permite",
        "shelves-not-full": "Los estantes tienen huecos",
      },
    },
    expectedSales: {
      title: "Ventas previstas",
      description:
        "Lo que se espera que venda todo lo incluido en este planograma, sumado; se cuenta una vez por producto, sean cuales sean sus frentes. Léalo junto a las puntuaciones de la izquierda: un planograma más ordenado que elimina productos se ve mejor allí y peor aquí.",
      emptyReason:
        "Este planograma no tiene cifras de ventas reales; cada producto lleva el mismo valor de marcador de posición, por lo que un total sería un número inventado. Vuelva a ejecutar la carga de datos para incorporar las ventas.",
    },
  },
  planogramProductDetails: {
    bulkWeight: "{{weight}} lb · VOLUMINOSO",
    weight: "Peso",
    weightValue: "{{weight}} lb",
    itemId: "ID de artículo",
    notAvailable: "No disponible",
    stockCoverUnavailable: "La cobertura de existencias no está disponible para este mobiliario.",
    capacity: "Capacidad",
    dos: "DOS",
    mos: "MOS",
    dosTitle:
      "Días de cobertura, sumados en las exhibiciones de este producto en el plan mostrado.",
    mosTitle: "Cumplimiento del mínimo en estante. 100% cumple el mínimo.",
    daysUnit: " días",
    sales: "Ventas",
    ranking: "Clasificación",
    profit: "Beneficio",
  },
  planogramHover: {
    detailsLabel: "Detalles del planograma",
    source: {
      before: "Antes",
      after: "Después",
      saved: "Plan guardado",
    },
    inspectionPaused: "Parpadeo en pausa mientras inspecciona · salga del producto para reanudar.",
  },
  pegboardFacingChange: {
    indicator: "Actualización de facing: {{changeType}}",
    inserted: "Insertado",
    swappedIn: "Intercambiado en",
    facingsIncreased: "Facings aumentados",
    facingsDecreased: "Facings reducidos",
    swappedOut: "Intercambiado fuera",
    deleted: "Eliminado",
  },
  editShelfModal: {
    menuLabel: "Editar estante",
    multipleShelvesEditUnavailable:
      "Editar estante solo está disponible cuando se selecciona un estante.",
    title: "Editar estante",
    widthLabel: "Ancho del estante (pulgadas)",
    widthPlaceholder: "Ingresa el ancho del estante",
    mergedWidthDisabled: "No se puede cambiar el ancho de los estantes combinados.",
    merchandisableWidthLabel: "Ancho comercializable (pulgadas)",
    merchandisableWidthPlaceholder: "Ingresa el ancho comercializable",
    mergedMerchandisableWidthDisabled:
      "No se puede cambiar el ancho comercializable de los estantes combinados.",
    obstructionMerchandisableWidthDisabled:
      "Un obstáculo bloquea parte de este estante, así que su ancho comercializable viene del planograma.",
    merchandisableSpaceLabel: "Espacio comercializable",
    invalidWidth: "Ingresa un número positivo válido para el ancho del estante.",
    invalidMerchandisableWidth:
      "Ingresa un ancho comercializable válido dentro del ancho del estante.",
    alignLabel: "Alineación del estante",
    alignLeft: "Izquierda",
    alignRight: "Derecha",
    alignBetween: "Entre",
    alignAround: "Alrededor",
    changeShelfTypeTitle: "¿Cambiar el tipo de estante a {{shelfType}}?",
    incompatibleProductDescriptionOneShelf:
      "1 producto de este estante no se puede colocar en un accesorio {{shelfType}} ({{names}}). Al guardar, se moverá a la lista sin surtido.",
    incompatibleProductDescriptionMultipleShelves:
      "1 producto de estos estantes no se puede colocar en un accesorio {{shelfType}} ({{names}}). Al guardar, se moverá a la lista sin surtido.",
    incompatibleProductsDescriptionOneShelf:
      "{{count}} productos de este estante no se pueden colocar en un accesorio {{shelfType}} ({{names}}). Al guardar, se moverán a la lista sin surtido.",
    incompatibleProductsDescriptionMultipleShelves:
      "{{count}} productos de estos estantes no se pueden colocar en un accesorio {{shelfType}} ({{names}}). Al guardar, se moverán a la lista sin surtido.",
    incompatibleProductsAndMore: "y {{count}} más",
    changeAndUnrange: "Cambiar y quitar del surtido",
  },
  cdtTreeEditor: {
    button: "Árbol CDT",
    accessDenied: "No tienes permiso para ver los árboles de decisión.",
    loadingCategory: "Cargando árbol CDT de categoría...",
    categoryLoadFailed: "No se pudo cargar el árbol CDT de categoría",
    invalidCategory: "El ID de categoría no es válido.",
    invalidSelection: "La selección de versión o categoría no es válida.",
    loadingTree: "Cargando versión...",
    treeLoadFailed: "No se pudo cargar la versión.",
    refreshFailed: "No se pudo actualizar esta versión. Estás editando la última copia cargada.",
    refreshRetry: "Reintentar",
    saveSuccess: "¡Jerarquía CDT guardada correctamente!",
    saveFailed: "No se pudo guardar la jerarquía CDT",
    saveUnavailable: "Este borrador CDT local no se puede guardar en la API.",
    saveNewUnavailable: "Guardar una nueva jerarquía CDT aún no está disponible.",
    saveNewSuccess: "Se creó {{version}}. Tus cambios se guardaron en la nueva versión.",
    saveNewUnsaved:
      "Se creó {{version}}, pero tus cambios aún no se pudieron guardar en ella. Guarda de nuevo para reintentar.",
    nextUnavailable: "La navegación siguiente aún no está disponible.",
    resetSuccess: "Jerarquía CDT restablecida con datos ETL.",
    resetFailed: "No se pudo restablecer la jerarquía CDT.",
    resetRefreshFailed:
      "El restablecimiento se completó, pero no se pudo cargar la jerarquía actualizada. Recarga la página para continuar.",
    unassigned: "(Sin asignar)",
    versions: {
      title: "Árboles de decisión",
      versionsTab: "Versiones",
      storesTab: "Tiendas",
      category: "Categoría {{categoryId}}",
      searchVersions: "Buscar versiones",
      searchStores: "Buscar tiendas",
      versionCount: "{{visible}} de {{total}} versiones",
      storeCountSummary:
        "{{visible}} de {{total}} tiendas · {{pinned}} fijadas · {{onPrimary}} en la principal",
      id: "ID",
      name: "Nombre",
      source: "Origen",
      primaryColumn: "CDT principal",
      storesColumn: "Tiendas",
      updated: "Actualizado",
      open: "Abrir",
      user: "Usuario",
      etlReadOnly: "ETL · Solo lectura",
      setPrimary: "Establecer como principal",
      primaryStar: "★ CDT principal",
      primary: "Principal",
      pinned: "Fijada",
      storeCount: "{{count}} {{storeLabel}}",
      storeCountWithPrimary: "{{count}} {{storeLabel}} ({{onPrimaryCount}} en la principal)",
      store: "tienda",
      stores: "tiendas",
      pinnedStore: "tienda fijada",
      pinnedStores: "tiendas fijadas",
      moveVerbSingular: "pasará",
      moveVerbPlural: "pasarán",
      keepVerbSingular: "conservará su versión",
      keepVerbPlural: "conservarán sus versiones",
      revisionDate: "{{date}}",
      storeCode: "Código de tienda",
      storeName: "Nombre de tienda",
      versionUsed: "Versión usada",
      storeUses: "Uso",
      cluster: "Clúster",
      allClusters: "Todos los clústeres",
      region: "Región",
      bays: "Módulos",
      versionReference: "#{{id}} {{name}}",
      unnamedStore: "Tienda sin nombre",
      unknownVersion: "Versión desconocida",
      loadingVersions: "Cargando versiones...",
      versionsLoadFailed: "No se pudieron cargar las versiones.",
      loadingStores: "Cargando tiendas...",
      storesLoadFailed: "No se pudieron cargar las tiendas.",
      noVersions: "Esta categoría no tiene versiones.",
      noMatchingVersions: "No hay versiones que coincidan con la búsqueda.",
      noStores: "No hay tiendas para esta categoría.",
      noMatchingStores: "No hay tiendas que coincidan con la búsqueda.",
      retry: "Reintentar",
      confirmPrimaryTitle: "¿Establecer esta versión como CDT principal?",
      confirmPrimaryDescription:
        "{{onPrimaryCount}} {{onPrimaryStoreLabel}} en la principal {{moveVerb}} de {{oldVersion}} a {{nextVersion}}; {{pinnedCount}} {{pinnedStoreLabel}} {{keepVerb}}.",
      cancel: "Cancelar",
      primaryUpdated: "{{version}} ahora es el CDT principal.",
      primaryUpdateFailed: "No se pudo establecer el CDT principal.",
      newCdt: "Nuevo CDT",
      cloneCreated: "Se creó {{version}}.",
    },
  },
  cdtClone: {
    titleNewCdt: "Nuevo CDT",
    titleSaveNew: "Guardar como nueva versión",
    close: "Cerrar",
    sourceLabel: "Copiar de",
    sourcePlaceholder: "Selecciona una versión",
    sourceMissing: "No hay ninguna versión para copiar",
    sourceEtl: "ETL",
    sourceUser: "Usuario",
    sourcePrimary: "Principal",
    sourceStoreCount: "{{count}} tiendas",
    sourceStoreCount_one: "{{count}} tienda",
    nameLabel: "Nombre",
    namePlaceholder: "Nombre de la nueva versión",
    defaultName: "{{name}} (copia)",
    duplicateName: "Ya existe una versión con este nombre",
    nameTooLong: "Usa {{max}} caracteres o menos (ahora {{count}}).",
    failed: "No se pudo crear la nueva versión. Inténtalo de nuevo.",
    note: "La nueva versión es editable, no es el CDT principal y no tiene tiendas fijadas.",
    cancel: "Cancelar",
    confirmNewCdt: "Crear",
    confirmSaveNew: "Guardar nueva versión",
    creating: "Creando…",
  },
  cdtWarnings: {
    nodeNameBlank: "El nombre del nodo no puede estar vacío.",
    subgroupNameBlank: "El nombre del subgrupo no puede estar vacío.",
    cannotAddBelow: "No se puede agregar un subgrupo debajo de CDT3.",
    saveParentFirst: "Guarda el nuevo padre antes de agregar otro subgrupo.",
    cdt0CannotReparent: "Los nodos CDT0 no se pueden reasignar.",
    cannotReparentIntoSubtree: "Un nodo no se puede reasignar dentro de su propio subárbol.",
    nodeNotFound: "No se encontró el nodo {{node}}.",
    parentNotFound: "No se encontró el nodo padre {{node}}.",
    invalidReorder: "La reordenación referencia un nodo no válido.",
    reorderSiblings: "Solo se pueden reordenar hermanos bajo el mismo padre.",
    invalidMerge: "La combinación referencia un nodo no válido.",
    invalidNodeParent: "La referencia del nodo o padre no es válida.",
    targetParentLevel: "El padre objetivo debe ser {{expected}}, pero es {{actual}}.",
    renameCollision: "Se detectó una colisión de nombres con el nodo {{node}}.",
  },
  cdtTable: {
    hierarchyNode: "Nodo de jerarquía",
    productCount: "Cantidad de productos",
    alerts: "Alertas",
    reorder: "Reordenar",
    products: "productos",
    clean: "Limpio",
    prioritySequence: "Secuencia de prioridad",
    priorityDescription: "Prioridad mínima derivada de los productos descendientes",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    fitView: "Ajustar vista",
    productCountValue: "{{count}} productos",
  },
  cdtHeader: {
    tree: "Árbol",
    list: "Lista",
    priority: "Prioridad CDT",
    undo: "Deshacer",
    redo: "Rehacer",
    save: "Guardar",
    togglePriority: "Alternar insignias de prioridad",
    expandAll: "Expandir todo",
    collapseAll: "Contraer todo",
    resolveAlerts: "Resolver alertas",
    category: "CDT 0: Categoría",
    categoryName: "Categoría",
    segmentName: "Segmento",
    brandName: "Marca",
    flavourName: "Sabor",
    revertChanges: "Revertir cambios",
    saveNew: "Guardar nuevo",
    saveNewVersion: "Guardar nueva versión",
    next: "Siguiente",
    breadcrumb: "Ruta de navegación",
    breadcrumbCategories: "Categorías",
    breadcrumbDecisionTrees: "Árboles de decisión",
    chipEtl: "ETL",
    chipPrimary: "CDT principal",
    sourceEtl: "Instantánea ETL",
    sourceEtlDated: "Instantánea ETL · {{date}}",
    sourceUser: "Versión de usuario",
    updated: "Actualizado {{date}}",
    readOnlyBanner:
      "CDT ETL — solo lectura. Los cambios se guardan como una nueva versión; esta se mantiene como se cargó.",
  },
  cdtStores: {
    title: "Tiendas en {{version}}",
    close: "Cerrar",
    closeButton: "Cerrar",
    intro:
      "Marca las tiendas que deben usar esta versión. Las tiendas sin marcar vuelven al CDT principal.",
    introPrimary:
      "Las tiendas en la principal ya usan esta versión. Marcar una la fija aquí para que un cambio de principal posterior no la mueva.",
    introReadOnly:
      "Puedes ver qué tiendas usan esta versión. Fijar tiendas requiere el permiso de edición de CDT.",
    searchPlaceholder: "Buscar por código o nombre de tienda",
    cluster: "Clúster",
    allClusters: "Todos los clústeres",
    region: "Región",
    allRegions: "Todas las regiones",
    bays: "Módulos",
    allBays: "Todos los módulos",
    selectVisible: "Seleccionar visibles",
    deselectVisible: "Deseleccionar visibles",
    counter: "{{visible}} de {{total}} tiendas · {{selected}} seleccionadas",
    storeCode: "Código de tienda",
    storeName: "Nombre de tienda",
    versionUsed: "Versión usada",
    change: "Cambio",
    unnamedStore: "Tienda sin nombre",
    unknownVersion: "Versión desconocida",
    primary: "Principal",
    pinned: "Fijada",
    hintPinnedHere: "fijada en #{{id}}",
    hintPinned: "fijada en #{{id}}",
    hintPrimary: "principal",
    hintMovesFrom: "pasa de #{{id}}",
    hintMovesFromPrimary: "pasa de la principal",
    hintReturnsToPrimary: "vuelve a la principal",
    noMatchingStores: "No hay tiendas que coincidan con los filtros.",
    progress: "Aplicando {{done}} de {{total}}…",
    failuresTitle: "{{count}} cambio(s) no se aplicaron. Los demás están guardados.",
    failurePin: "No se pudo fijar la tienda {{store}}",
    failureUnpin: "No se pudo devolver la tienda {{store}} a la principal",
    retryFailed: "Reintentar {{count}} fallidos",
    cancel: "Cancelar",
    done: "Listo ({{pin}} por fijar, {{unpin}} por liberar)",
    applying: "Aplicando…",
    summary: "{{pinned}} {{pinnedLabel}}, {{unpinned}} devueltas a la principal",
    pinnedOne: "fijada",
    pinnedMany: "fijadas",
    openStores: "Tiendas",
    storesChip: "{{count}} {{storeLabel}}",
  },
  cdtNext: {
    title: "Siguiente paso para {{version}}",
    close: "Cerrar",
    storesUsing: "{{count}} tiendas usan esta versión y quedarán preseleccionadas.",
    storesUsing_one: "{{count}} tienda usa esta versión y quedará preseleccionada.",
    generateTitle: "Generar nuevo merchflow",
    generateText:
      "Inicia un flujo UHD para esta categoría con las tiendas que usan esta versión preseleccionadas. Las reglas del planograma se abren con CDT principal / fijado seleccionado.",
    updateTitle: "Actualizar planogramas existentes",
    updateText:
      "Elige un flujo de esta categoría que ya tenga planogramas de tienda y ejecuta una actualización con CDT principal / fijado seleccionado.",
    flowLabel: "Flujo",
    flowPlaceholder: "Selecciona un flujo",
    flowsLoading: "Cargando flujos…",
    noFlows: "Ningún flujo de esta categoría tiene planogramas de tienda todavía.",
    flowsLoadFailed: "No se pudieron cargar los flujos de esta categoría.",
    categoryLoadFailed:
      "No se pudieron cargar los datos de esta categoría, así que el siguiente paso aún no puede empezar.",
    retry: "Reintentar",
    cancel: "Cancelar",
    generateAction: "Generar nuevo merchflow",
    updateAction: "Abrir actualización de flujo",
    nextDisabledDirty: "Guarda tus cambios antes de continuar.",
    next: "Siguiente →",
    flowFromVersion:
      "Iniciado desde la versión CDT {{version}}. {{count}} {{storeLabel}} la usan y quedan preseleccionadas en el paso de tiendas; las reglas del planograma usarán por defecto CDT principal / fijado.",
  },
  cdtFlowReleases: {
    title: "Versiones de flujo",
    tooltip: "Las versiones de flujo se aplican a las tiendas de ese flujo que no tienen fijación.",
    tree: "Árbol",
    flow: "Flujo",
    basePog: "Planograma base",
    release: "Versión",
    finalized: "Finalizado",
    openBasePog: "POG base #{{id}}",
    saveAsVersion: "Guardar como versión de categoría",
    defaultVersionName: "Versión de {{flow}}",
  },
  cdtCategorySummary: {
    loading: "Cargando…",
    summary: "{{versions}} {{versionLabel}} · {{pinned}} {{pinnedLabel}} fijadas",
    version: "versión",
    versions: "versiones",
    store: "tienda",
    stores: "tiendas",
  },
  storePogsCdtVersion: {
    header: "Versión CDT",
    pinned: "fijada",
    primary: "principal",
    unknown: "—",
  },
  cdtSaveConfirm: {
    title: "¿Guardar los cambios en esta versión?",
    description:
      "{{count}} {{storeLabel}} {{useVerb}} esta versión ({{pinnedCount}} fijadas, {{primaryCount}} por la principal). Su próxima generación o actualización tomará la nueva secuencia.",
    store: "tienda",
    stores: "tiendas",
    useVerbSingular: "usa",
    useVerbPlural: "usan",
    noStores: "Ninguna tienda usa esta versión todavía.",
    usageLoading: "Comprobando qué tiendas usan esta versión…",
    usageFailed: "No se pudo comprobar qué tiendas usan esta versión. Reintenta antes de guardar.",
    retry: "Reintentar",
    close: "Cerrar confirmación de guardado",
    cancel: "Cancelar",
    confirm: "Guardar",
  },
  cdtRename: {
    title: "Colisión al renombrar grupo",
    existing: '¡Ya existe un grupo hermano llamado "{{name}}"!',
    mergeDescription: "El renombrado combinará ambos grupos y sus subárboles descendientes.",
    cancel: "Cancelar",
    close: "Cerrar diálogo de colisión de nombres",
    confirm: "Confirmar combinación",
  },
  cdtDelete: {
    title: "Confirmación de eliminación del subárbol",
    question: '¿Seguro que deseas eliminar el grupo "{{name}}"?',
    descendants: "Nodos CDT descendientes que se eliminarán:",
    close: "Cerrar confirmación de eliminación",
    cancel: "Cancelar",
    delete: "Eliminar subárbol",
  },
  cdtReset: {
    title: "Restablecer con datos ETL",
    warning: "Esto descarta la personalización guardada y los cambios de jerarquía sin guardar.",
    close: "Cerrar confirmación de restablecimiento",
    cancel: "Cancelar",
    confirm: "Restablecer con ETL",
    resetting: "Restableciendo…",
  },
  cdtCanvas: {
    categoryRoot: "Categoría",
    selectNode: "Seleccionar {{name}}",
    expandNode: "Expandir {{name}}",
    collapseNode: "Contraer {{name}}",
    moveUp: "Mover arriba",
    moveDown: "Mover abajo",
  },
  cdtNodeInspector: {
    title: "Inspector de nodos",
    group: "Grupo",
    categoryRoot: "Raíz de categoría",
    nodeName: "Nombre del nodo",
    aggregateItemCount: "Elementos en la jerarquía, incluidos descendientes ({{count}})",
    immediateChildren: "Hijos inmediatos",
    noImmediateChildren: "No hay hijos inmediatos.",
    viewProducts: "Ver productos",
    saveBeforeViewingProducts: "Guarda la jerarquía antes de ver productos.",
    addSubgroup: "Agregar subgrupo {{level}}",
    newGroupName: "Nombre del grupo {{level}} nuevo",
    addSubgroupAction: "Agregar subgrupo",
    deleteGroup: "Eliminar este grupo",
    activeAlerts: "Alertas activas ({{count}})",
    noActiveAlerts: "No hay alertas activas para este nodo.",
    suggestionsComingSoon: "Sugerencias (próximamente)",
    comingSoon: "Próximamente",
    selectNode: "Selecciona un nodo en el lienzo para inspeccionar sus detalles.",
    submitRename: "Confirmar renombrado",
    saveParentFirst: "Guarda el nuevo padre antes de agregar otro subgrupo",
  },
  cdtProducts: {
    regionLabel: "Productos en {{name}}",
    title: "Productos en {{name}}",
    directCountOne: "1 producto directo",
    directCount: "{{count}} productos directos",
    searchPlaceholder: "Buscar productos",
    close: "Cerrar panel de productos",
    loading: "Cargando productos…",
    loadFailed: "No se pudieron cargar los productos.",
    retry: "Reintentar",
    noProducts: "No hay productos asignados directamente a este nodo.",
    noSearchResults: "Ningún producto coincide con esta búsqueda.",
    pageSize: "Filas por página",
    product: "Producto",
    segment: "Segmento",
    subcategory: "Subcategoría",
    brand: "Marca",
    sku: "SKU",
    price: "Precio",
    position: "Posición",
    notAvailable: "No disponible",
  },
  cdtAlerts: {
    renamePlaceholder: "Nuevo nombre...",
    rename: "Renombrar",
    groupScope: "Grupo: {{name}}",
    draftScope: "Alertas del borrador",
    affectedGroup: "Grupo afectado: {{name}}",
    affectedDraft: "Ámbito afectado: borrador actual",
    similarGroup: 'El nombre del grupo CDT "{{name}}" se repite bajo el mismo padre',
    guidedTitle: "Resolución guiada de alertas",
    close: "Cerrar resolución de alertas",
    similarGroups: "Grupos similares:",
    affectedScope: "Ámbito afectado",
    affectedAlertScope: "Ámbito de alertas afectadas",
    allActive: "Todas las alertas activas",
    showing: "Mostrando {{shown}} de {{total}} alertas activas",
    noAlerts: "No hay alertas activas de jerarquía CDT.",
    noScopedAlerts: "No hay alertas activas en este ámbito afectado.",
    focusGroup: "Enfocar grupo",
    editRequired: "Se requiere el modo de edición para reparar",
  },
  cdtStudioTab: {
    tabLabel: "CDT Studio",
    configurationLabel: "Configuración de CDT Studio",
    unavailable: {
      notPlanogram: "CDT Studio solo está disponible en el editor de planogramas.",
      missingMerchflow: "Abre este planograma desde un merchflow para usar CDT Studio.",
      missingPermission: "Tu rol necesita permiso para editar CDT y usar CDT Studio.",
      categoryUnavailable:
        "CDT Studio necesita exactamente una categoría en el contexto del planograma actual.",
      configurationRequired:
        "No hay una configuración de CDT Studio disponible para esta categoría. Abre Categorías y guarda la configuración de esta categoría.",
      unsupportedFixtures:
        "CDT Studio no puede leer este planograma: un producto de tablero cuelga de un agujero no válido. Corrige su posición para usar CDT Studio.",
    },
  },
  planogramHighlights: {
    pinLabelToTop: "Fijar {{label}} arriba",
    unpinLabel: "Desfijar {{label}}",
  },
  cdtPriorityOrder: {
    tabLabel: "Reordenar CDTs",
    cdtLevel: "Nivel CDT",
    cdt0: "CDT0",
    cdt1: "CDT1",
    cdt2: "CDT2",
    cdt3: "CDT3",
    searchPlaceholder: "Buscar CDT o producto",
    expandGroup: "Expandir {{groupName}}",
    collapseGroup: "Contraer {{groupName}}",
    cdt0NoPriority: "CDT0 usa variante y no tiene campo de prioridad guardado",
    productCount: "{{count}} producto",
    productCountPlural: "{{count}} productos",
    unplaced: "Sin colocar",
    includesUnplaced: "Incluye sin colocar",
    ranged: "En surtido",
    unranged: "Sin surtido",
    placementLabel: "Bahía {{bayNo}}, Estante {{shelfNo}}",
    pegboardPlacementLabel: "Tablero {{pegboardId}}, agujero {{holeNoLeft}}, {{holeNoTop}}",
    mixed: "Mixto",
    noCdt: "(Sin CDT)",
    noData: "Sin datos de prioridad CDT",
    mode: "Modo",
    imageMode: "Imagen",
    labelMode: "Etiqueta",
    productCanvas: "Productos CDT",
    selectProduct: "Seleccionar {{productName}}",
    moveProductLeft: "Mover {{productName}} a la izquierda",
    moveProductRight: "Mover {{productName}} a la derecha",
    zoom: "Zoom",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    resetZoom: "Restablecer zoom",
    viewportControls: "Controles de vista del planograma",
    resetViewport: "Restablecer vista",
    reset: "Restablecer",
    planogramContainers: "Contenedores del planograma",
    planogramProducts: "Productos del planograma",
    planogramPegboards: "Tableros de clavijas del planograma",
    planogramPlacements: "Colocaciones del planograma",
    planogramShelves: "Estantes del planograma",
    planogramFixtures: "Accesorios del planograma",
    selectContainer: "Seleccionar {{label}}",
    selectPegboard: "Seleccionar tablero de clavijas {{id}}",
    selectPlacement: "Seleccionar {{label}}",
    selectShelf: "Seleccionar estante {{shelfNo}}",
    selectFixture: "Seleccionar {{fixtureName}} {{shelfNo}}",
    shelf: "Estante {{shelfNo}}",
    fixture: "{{fixtureName}} {{shelfNo}}",
    riserFixture: "elevador",
    hangcellFixture: "celda colgante",
    moveLeft: "Mover a la izquierda",
    moveRight: "Mover a la derecha",
    resizeShelfWider: "Ampliar el estante {{shelfNo}}",
    resizeShelfNarrower: "Estrechar el estante {{shelfNo}}",
    resizeShelfWiderText: "Ampliar estante",
    resizeShelfNarrowerText: "Estrechar estante",
    resizeFixtureNarrower: "Estrechar {{fixtureName}} {{shelfNo}}",
    resizeFixtureNarrowerText: "Estrechar accesorio",
    resizeFixtureWider: "Ampliar {{fixtureName}} {{shelfNo}}",
    resizeFixtureWiderText: "Ampliar accesorio",
    invalidPegboardHole: "Elige un orificio disponible en el tablero de clavijas.",
    shelfCollision: "Mueve el estante a una posición libre.",
    shelfResizeCollision: "Elige un tamaño que no se superponga con otro accesorio.",
    shelfMoveFailed: "No se pudo mover el estante. Prueba otra posición.",
    shelfResizeFailed: "No se pudo cambiar el tamaño del accesorio. Prueba otro tamaño.",
    pegboardMoveFailed:
      "No se pudo mover el producto en el tablero de clavijas. Prueba otro orificio.",
    productMoveRejected: "No se pudo mover el producto. Prueba otra posición.",
    planogramMoveFailed: "No se pudo completar el cambio del planograma. Inténtalo de nuevo.",
    labelOptions: {
      none: "Ninguno",
      brand: "Marca",
      categoryCode: "Código de categoría",
      cdt0: "CDT0",
      cdt1: "CDT1",
      cdt1Priority: "Prioridad CDT1",
      cdt2: "CDT2",
      cdt2Priority: "Prioridad CDT2",
      cdt3: "CDT3",
      cdt3Priority: "Prioridad CDT3",
      color: "Color",
      facings: "Frentes",
      name: "Nombre",
      price: "Precio",
      productCode: "Código de producto",
      quantity: "Cantidad",
      ranking: "Clasificación",
      salesAmount: "Importe de ventas",
      size: "Tamaño",
      subCategory: "Subcategoría",
      upc: "UPC",
      variant: "Variante",
    },
    confirmSnakingAriaLabel: "Confirmar patrón de serpenteo",
    snakingPatternAriaLabel: "Configuración del patrón de serpenteo",
    confirmSnakingTitle: "Confirmar patrón de serpenteo",
    confirmSnakingDescription:
      "Revisa las direcciones de las filas y el orden de filas de cada bahía antes de habilitar la edición de CDT.",
    snakingPatternTitle: "Configuración del patrón de serpenteo",
    snakingPatternDescription:
      "Revisa las direcciones configuradas de las filas y el orden de cada bahía.",
    aisleBreak: "Corte de pasillo",
    bayLabel: "Bahía {{bayNo}}",
    shelfLabel: "Estante {{shelfName}}",
    bayShelfOrderAriaLabel: "Orden de estantes de la bahía {{bayNo}}",
    shelfDirectionAriaLabel: "Dirección del estante {{shelfName}}",
    pegboardRowLabel: "Tablero {{pegboardId}}, fila {{rowNo}}",
    pegboardRowDirectionAriaLabel: "Dirección de la fila {{rowNo}} del tablero {{pegboardId}}",
    selectShelfOrder: "Seleccionar orden de estantes",
    topFirst: "De arriba hacia abajo",
    bottomFirst: "De abajo hacia arriba",
    selectDirection: "Seleccionar dirección",
    leftToRight: "De izquierda a derecha",
    rightToLeft: "De derecha a izquierda",
    incompleteSnakingConfiguration:
      "Completa la dirección de cada bahía y fila de recorrido. Todos los segmentos de un estante combinado deben usar la misma dirección.",
    confirm: "Confirmar",
    snakingUnavailableTitle: "Editor de planograma CDT no disponible",
    snakingUnavailableMessage:
      "Se admiten estantes REGULAR y tableros de clavijas. RISER, HANGCELL y otros accesorios no compatibles bloquean todo el editor de planograma CDT.",
    confirmSnakingBeforeDrag:
      "Confirma la configuración del patrón de serpenteo antes de usar arrastrar y soltar de CDT.",
    priorityOrderViolation:
      "Violación del orden de prioridad: el orden de recorrido no coincide con la prioridad CDT3 almacenada ascendente. Arrastrar y soltar está deshabilitado.",
    duplicateCdtPath:
      "Ruta CDT duplicada: el movimiento CDT y el recálculo de prioridades están deshabilitados hasta corregir el duplicado.",
    duplicateCdtPathDetails: "{{path}} — productos: {{productCodes}}",
    recalculationFailed:
      "No se pudo completar el recálculo total de prioridades. El planograma no ha cambiado.",
    productMoveFailed:
      "No se pudo mover el producto porque no se pudieron recalcular las prioridades CDT. El planograma no ha cambiado.",
    recalculatePriorities: "Recálculo total de prioridades",
    viewSnakingPattern: "Ver patrón de serpenteo",
    hideSnakingPattern: "Ocultar patrón de serpenteo",
  },
  unsavedChanges: {
    title: "Cambios sin guardar",
    description:
      "Tienes cambios sin guardar en este planograma. Guárdalos antes de salir o sal de todos modos y perderás los cambios.",
    keepEditing: "Seguir editando",
    leaveAnyway: "Salir de todos modos",
    save: "Guardar",
    saveFailed: "No se pudieron guardar los cambios del planograma",
  },
  productsCdtsChanged: {
    title: "Los CDT de los productos han cambiado",
    description:
      "Los cambios de CDT de los productos solo se pueden guardar en el planograma base o también actualizar los CDT de los productos de todas las tiendas",
    saveOnly: "Guardar solo",
    saveAndUpdateProducts: "Guardar y actualizar productos",
  },
  planogram: {
    facingsAndPlacement: "Frentes y colocación",
    assortment: "Surtido",
  },
  basePog: {
    unavailableTitle: "No hay un planograma base",
    unavailableMessage:
      "Esta tienda se importó desde PSA y no tiene un planograma base para revisar.",
  },
  sidebar: {
    performance: "Rendimiento",
    assortment: "Surtido",
    spacePlanning: "Planificación Espacio",
    imagine: "Imagine",
    categories: "Categorías",
    stores: "Tiendas",
    products: "Productos",
    fixtures: "Mobiliario",
    projects: "Proyectos",
    merchflows: "Merchflows",
    storeSummary: "Resumen de Tienda",
    users: "Usuarios",
    audit: "Auditoría",
    profile: "Perfil",
    settings: "Configuración",
    logout: "Cerrar Sesión",
  },
  storesPickList: {
    columnStore: "TIENDA",
    columnBaySize: "TAMAÑO DE BAHÍA",
    columnBusinessType: "TIPO DE NEGOCIO",
    columnActivityType: "TIPO DE ACTIVIDAD",
    searchPlaceholder: "Buscar tiendas",
    selectedCount: "{{selected}} seleccionadas / {{total}} en filtro",
    loadingStores: "Cargando tiendas...",
    nextButton: "Siguiente ({{count}} {{label}})",
    storeLabel: "tienda",
    storesLabel: "tiendas",
    columnCdtVersion: "VERSIÓN CDT",
    cdtPinned: "fijada",
    cdtPrimary: "principal",
    cdtVersionsInFlow: "Versiones CDT en este flujo: {{list}}",
    cdtVersionsNone: "Selecciona tiendas para ver qué versiones CDT usará este flujo.",
  },
  configCopilot: {
    name: "O",
    conciergePlanTitle: "Cómo configuraré esta ejecución para ti",
    conciergeAmbiguitiesTitle: "Lo que necesito que aclares",
    conciergeExceptionsTitle: "Ubicaciones y equipamiento específicos de cada tienda",
    conciergeProposed: "Propuesto · aún no aplicado",
    conciergeAccepted: "Aceptado para esta ejecución",
    conciergeMeasured: "Evidencia medida",
    conciergeCurrent: "Política actual · no confirmada de nuevo",
    conciergeLimit: "Límite conocido",
    conciergeNeedsDecision: "Necesito tu decisión",
    conciergeRecommendation: "O propone",
    conciergeNoExceptions: "Todavía no hay decisiones específicas de tienda aquí.",
    conciergeNext: "Lo revisaremos después de la decisión actual.",
    conciergeMoreEvidence: "{{count}} detalles medidos más",
    conciergeReviewed: "{{count}} puntos revisados",
    conciergeReady: "Ya están tomadas las decisiones necesarias. Revisa el plan antes de generar.",
    conciergePending: "Necesito tu decisión antes de generar esta ejecución.",
    conciergeHistory: "Conversación y cambios",
    conciergePlanReviewed: "detalles del plan",
    conciergeSupportingDetails: "Detalles adicionales",
    conciergeAlsoProposed: "También propuesto · aún no aplicado",
    conciergeSectionDetails: "Revisar los detalles registrados",
    conciergeRetryReview: "Reintentar la revisión de las tiendas",
    tagline: "pone las reglas de tus tiendas",
    advanced: "Ajustes avanzados",
    backToO: "Volver a O",
    thinking: "Mirando tus tiendas…",
    setup: "Reglas para estas tiendas",
    pick: "Elección de O",
    alwaysOn: "Siempre activo",
    fixFirst: "Arregla antes de ejecutar",
    worthKnowing: "Conviene saber",
    fix: "Arreglar",
    adjust: "Ajustar",
    use: "Usar",
    useAgain: "Usar de nuevo",
    redo: "Rehacer",
    undone: "Deshecho.",
    redone: "Rehecho.",
    undoTitle: "Deshacer: {{title}}",
    redoTitle: "Rehacer: {{title}}",
    done: "Hecho",
    details: "Detalles",
    lastRunRunning: "{{done}} de {{stores}} tiendas listas, en curso",
    lastRunStores: "Última ejecución, tienda por tienda",
    placeholder: 'Pídele a O, por ejemplo "más productos sin separar marcas"',
    send: "Enviar",
    store: "Tienda",
    placed: "Colocados",
    missing: "Sin colocar",
    lowShelves: "Baldas con huecos",
    bareShelves: "Baldas vacías",
    fill: "Espacio de balda usado",
    pastSupply: "Sobre el máximo de días de suministro",
    score: "Puntuación de orden",
    failed: "Falló",
    running: "En curso",
    generate: "Generar planogramas de tienda",
    cancel: "Cancelar",
    retry: "Reintentar",
    brandBlocks: "Bloques de marca",
    notUnderHorizontal: "No con bloques horizontales",
    askO: "Pregúntale a O",
    offline: "No puedo leer lo que escribes ahora; toca una sugerencia o usa Ajustes avanzados.",
    notDone: "No se pudo hacer. Tus reglas siguen como las dejaste.",
    notSwitched: "No se pudo cambiar {{label}}. Tus reglas siguen como las dejaste.",
    notReread: "Cambio guardado; las notas de arriba pueden estar desactualizadas.",
    noDetails: "No se pudieron cargar los detalles. Tus reglas siguen como las dejaste.",
    briefFailed: "O no pudo leer tus tiendas. Tus reglas siguen como las dejaste.",
    doneTitle: "Puesto para la próxima ejecución: {{title}}.",
    alreadyFixed: "Eso ya está arreglado.",
    fixUnavailable: "No encontré una solución para ese hallazgo en esta ejecución.",
    changedSinceRun: "Cambiado desde la última ejecución",
    changedFromSetup: "Cambiado sobre las elecciones de O",
    backToLastRun: "Volver a las reglas de la última ejecución",
    backToSetup: "Volver a las elecciones de O",
    backOnLastRun: "De vuelta a las reglas de la última ejecución: {{rows}}.",
    backOnSetup: "De vuelta a las elecciones de O: {{rows}}.",
    copiesBase: "Se copia la base en cada tienda, así que estas reglas no se aplican.",
    turnOff: "Desactivar",
    favouriteFirst: "Solo los planogramas base favoritos llegan a Store Review.",
    onlyGenerate: "Solo generar",
    favouriteAndGenerate: "Marcar favorito y generar",
    verdictLost: "O perdió el hilo de esta ejecución. Recarga la página para revisarla.",
    readingRun: "Leyendo la ejecución…",
    olderRunShown:
      "Se muestra la última ejecución terminada; hay una nueva en curso ({{done}} de {{stores}} hechas).",
    advancedChangedOne: "Cambiaste 1 ajuste en Avanzados: {{names}}.",
    advancedChangedMany: "Cambiaste {{count}} ajustes en Avanzados: {{names}}.",
    andMore: "{{names}} y {{count}} más",
    setByO: "Puesto por O: {{change}}",
    confirmedWithO: "Confirmado con O: {{change}}",
    leftOutUnprotected: "{{count}} no protegidos como surtido básico",
    leftOutProtectedOf: "{{protected}} de {{products}} protegidos",
    leftOutWidthShort: "{{count}} no cabían en el espacio de su bloque de marca",
    leftOutSupply: "{{count}} no llegaban al mínimo de días de suministro",
    leftOutBroken: "{{count}} partirían un bloque de marca o la secuencia",
    leftOutBeforeSolve: "{{count}} retirados antes de colocar",
    studioPlanSkippedOne: "1 tienda ignoró tu plan de CDT Studio",
    studioPlanSkippedMany: "{{count}} tiendas ignoraron tu plan de CDT Studio",
    qa: {
      good: "¿Qué está bien?",
      bad: "¿Qué está mal?",
      better: "¿Qué se puede mejorar?",
      storesRun: "¿Cómo fue esta ejecución?",
      storesResults: "¿Qué muestran estos resultados de las tiendas?",
      storesAttention: "¿Qué tiendas necesitan atención?",
      storesNext: "¿Qué debería revisar primero?",
      whyScore: "¿Por qué esta puntuación?",
      missing: "¿Qué falta aquí?",
      cdtReady: "¿Está listo el CDT?",
      hello:
        "Pregúntame sobre este merchflow. Puedo explicar lo que encuentre, pero no haré cambios.",
      placeholder: "Pregunta por este merchflow",
      placeholderRunning: "Pregunta por las tiendas ya terminadas",
      running: "Algunas tiendas aún se están generando.",
      thinking: "O está leyendo el merchflow…",
      unavailable: "Ahora no puedo responder preguntas.",
      notAnswered: "No se envió. ¿Preguntas otra vez?",
      rateLimited: "O está ocupado. Vuelve a intentarlo en {{count}} segundos.",
      rateLimitReady: "O ya puede intentarlo de nuevo.",
      close: "Cerrar",
      feedbackUp: "Útil",
      feedbackDown: "No es útil",
      feedbackWhat: "¿Qué estaba mal o qué faltaba?",
      feedbackSend: "Enviar",
      feedbackThanks: "Gracias",
      feedbackRetry: "Reintentar",
    },
    whatISee: "Lo que veo",
    sketchMoreBrands: "+{{count}} marcas más",
    sketchMoreBrands_one: "+{{count}} marca más",
    sketchEnlarge: "Ampliar {{label}}",
    whatISeeCount: "Lo que veo ({{count}})",
    moreSettings: "Más ajustes",
    moreStores: "{{count}} tiendas más",
    technicalError: "Error técnico de {{store}}",
    copiedBase: "Base copiada",
    currentPlan: "Plan actual para las tiendas restantes",
    blockerInDetails: "Hay un problema que impide generar. Revísalo en Detalles antes de generar.",
    copyMatchingSummary:
      "Copiar la disposición y el surtido base en {{copied}} tiendas compatibles; generar una disposición nueva para las otras {{fresh}} con los ajustes avanzados.",
    freshSummary:
      "Generar una disposición nueva para las {{count}} tiendas con los ajustes avanzados.",
    layoutPendingSummary:
      "{{eligible}} de {{total}} tiendas podrían coincidir con la base; elige cómo disponer las tiendas.",
    copyRangeCost:
      "{{count}} tiendas con muebles compatibles tienen otro surtido; la copia usa el surtido base allí.",
    copyOverrideCost: "La copia sustituye {{reason}} en {{count}} tiendas.",
    summarySet: "O configuró {{label}} en {{value}}{{detail}}",
    summaryConfirmed: "Se confirmó con O que {{label}} es {{value}}{{detail}}",
    summaryPolicySet: "O configuró: {{policy}}{{detail}}",
    summaryPolicyConfirmed: "Confirmado con O: {{policy}}{{detail}}",
    recommendedChoice: "O recomienda esta opción",
    currentChoice: "Opción actual",
    choiceCost: "Consecuencia: {{cost}}",
    preferFullShelves: "Preferir estantes llenos",
    allowShelfGaps: "No penalizar espacios vacíos en los estantes",
    allowShelfMoves: "Permitir cambios de altura de estantes",
    keepShelfHeights: "Mantener fijas las alturas de estantes",
    rankSales: "Priorizar por ventas",
    rankProfit: "Priorizar por beneficio",
    useReleasedCdt: "Usar la versión publicada de CDT Studio",
    useStoreLabels: "Usar las etiquetas de productos de la tienda",
    settingOn: "activado",
    settingOff: "desactivado",
    settingUnset: "sin configurar",
    settingCustom: "valor personalizado",
    summaryKept: "Se mantiene {{label}}: {{reason}}",
    summaryLimit: "Límite de generación: {{line}}",
    whatISet: "Lo que ajusté",
    anythingToChange: "¿Cambiarías algo?",
    kept: "Elegiste {{yours}}; yo elegiría {{oWould}}: {{reason}}",
    keptNoReason: "Elegiste {{yours}}; yo elegiría {{oWould}}",
    runAgain: "Ejecutar de nuevo",
    openStorePlanograms: "Abrir planogramas de tienda",
    close: "Cerrar",
  },
  aisleBreaks: {
    and: "y",
    or: "o",
    listMore: "{{list}} y {{count}} más",
    suggestion: {
      gap: "Las bahías {{left}} y {{right}} están a {{gap}} {{unit}} de distancia. Se tratan como un solo pasillo.",
      gapWithoutUnit:
        "Las bahías {{left}} y {{right}} están a {{gap}} de distancia. Se tratan como un solo pasillo.",
      units: {
        inches: "pulg.",
        centimetres: "cm",
      },
      unmergedSeam:
        "Ningún estante continúa de la bahía {{left}} a la bahía {{right}}. Se tratan como un solo pasillo.",
      breakHere: "Separar el pasillo aquí",
      declared: "Separación de pasillo después de la bahía {{bayNo}}. La acabas de definir tú.",
      failed: "No se guardó la separación de pasillo después de la bahía {{bayNo}}.",
      loading: "Revisando los muebles de la tienda en busca de separaciones de pasillo...",
      loadFailed:
        "No se pudieron revisar los muebles de la tienda en busca de separaciones de pasillo.",
      retry: "Reintentar",
    },
    result: {
      noBrandCrossesOne: "Ninguna marca cruza la separación después de la bahía {{bayNo}}.",
      noBrandCrossesEither:
        "Ninguna marca cruza ninguna de las dos separaciones (después de las bahías {{bayNos}}).",
      noBrandCrossesAny:
        "Ninguna marca cruza ninguna separación (después de las bahías {{bayNos}}).",
      noBrandCrossesThese: "Ninguna marca cruza las separaciones después de las bahías {{bayNos}}.",
      brandOnBothSides:
        "{{brand}} está a ambos lados de la separación después de la bahía {{bayNo}}: {{left}} y {{right}}.",
      brandOnBothSidesPlain:
        "{{brand}} está a ambos lados de la separación después de la bahía {{bayNo}}.",
      bayCouldNotHoldOne: "La bahía {{bayNo}} no pudo contener 1 producto: {{products}}.",
      bayCouldNotHoldMany: "La bahía {{bayNo}} no pudo contener {{count}} productos: {{products}}.",
      baysCouldNotHoldOne:
        "Las bahías {{first}}–{{last}} no pudieron contener 1 producto: {{products}}.",
      baysCouldNotHoldMany:
        "Las bahías {{first}}–{{last}} no pudieron contener {{count}} productos: {{products}}.",
      bayHasNo: "La bahía {{bayNo}} no tiene {{sections}}.",
      baysHaveNo: "Las bahías {{first}}–{{last}} no tienen {{sections}}.",
      movedAfter:
        "{{what}} se movió después de {{after}} para que las marcas quepan entre las separaciones.",
      movedToFront:
        "{{what}} se movió al inicio para que las marcas quepan entre las separaciones.",
      movedToFrontOf:
        "{{what}} se movió al inicio de {{within}} para que las marcas quepan entre las separaciones.",
      editedAfterGeneration:
        "Editado después de la generación: las marcas pueden cruzar la separación.",
      columnHeader: "Separaciones de pasillo",
    },
    brandLevel: {
      unresolvedOne:
        "1 tienda tiene una separación de pasillo, y el CDT de esta categoría no dice qué nivel es la marca.",
      unresolvedMany:
        "{{count}} tiendas tienen una separación de pasillo, y el CDT de esta categoría no dice qué nivel es la marca.",
      setBrandLevel: "Definir la marca",
      question: "¿Cuál de estos es la marca?",
      noLevels: "El CDT de esta categoría no tiene nada para elegir.",
      save: "Guardar",
      cancel: "Cancelar",
      saved: "{{name}} es la marca.",
      generateOne: "Generar esta tienda",
      generateMany: "Generar estas {{count}} tiendas",
      noStudioProfile: "Esta categoría todavía no tiene un perfil de CDT Studio.",
      noAttributeNamesLevel:
        "CDT Studio no tiene nada que nombre solo a {{name}}, así que no se puede guardar como la marca.",
      changed: "El CDT de esta categoría cambió. Vuelve a generar las tiendas para elegir.",
      failed: "No se guardó la marca.",
      runReadFailed: "No se pudieron cargar todas las tiendas rechazadas.",
      retry: "Reintentar",
    },
  },
  products: {
    palletEligible: "Apto para pallet",
    yes: "Sí",
    no: "No",
  },
  primaryBlocking: {
    label: "Bloqueo principal:",
    vertical: "Vertical",
    horizontal: "Horizontal",
    release: "versión del estudio {{releaseId}}",
    notFinalized: "estudio no finalizado",
    tooltipVertical:
      "Los planogramas de tienda usan bloqueo vertical por defecto, medido contra los CDT finalizados en CDT Studio.",
    tooltipRows:
      "Los planogramas de tienda usan bloqueo horizontal por defecto: CDT Studio finalizó los CDT de esta pared para bloqueo horizontal.",
    tooltipNotFinalized:
      "Los planogramas de tienda usan bloqueo horizontal por defecto. Finaliza los CDT en CDT Studio para usar bloqueo vertical.",
  },
  tour: {
    start: "Recorrido",
    loadFlowsFailed: "No se pudieron cargar tus flujos para el ejercicio",
    offer: {
      title: "¿Eres nuevo?",
      body: "Haz un ejercicio de tres minutos con uno de tus propios planogramas: leerlo, usar CDT Studio para que los planogramas de tienda lo sigan y configurar las reglas para generarlos. No se guarda ni se genera nada. También puedes empezarlo más tarde desde Recorrido, arriba en cualquier planograma base.",
      dismiss: "Ahora no",
      start: "Empezar el ejercicio",
    },
    card: {
      yourTurn: "Tu turno",
      end: "Terminar recorrido",
      close: "Cerrar",
      back: "Atrás",
      next: "Siguiente",
      skip: "Saltar este paso",
      start: "Empezar",
    },
    steps: {
      welcome: {
        title: "Aprende la pantalla del planograma",
        body: "Esto lleva unos tres minutos con uno de tus propios planogramas. Probarás tú mismo las funciones principales, incluido CDT Studio, que es cómo se hace que los planogramas de tienda se parezcan al planograma base. Nada de lo que hagas en el ejercicio se guarda ni se genera.",
      },
      "flow-header": {
        title: "En qué planograma estás",
        body: "El encabezado muestra el minorista, la categoría, el flujo y el planograma base. Revísalo primero cuando tengas varios flujos abiertos.",
      },
      "primary-blocking": {
        title: "Modo de bloqueo principal",
        body: "Cómo se bloquearán por defecto los planogramas de tienda. El bloqueo vertical, como el de este planograma, necesita el CDT finalizado en CDT Studio. El bloqueo horizontal coloca las marcas a lo largo del estante.",
      },
      "flow-steps": {
        title: "Dónde estás en el flujo",
        body: "Un flujo pasa de los mudmaps a CDT Studio, al planograma base y luego a los planogramas de tienda. Los pasos completados son enlaces, así que puedes volver a cualquiera de ellos.",
      },
      planogram: {
        title: "El planograma base",
        body: "Este es el planograma del que parte cada planograma de tienda. Arrastra productos para moverlos, desplázate para hacer zoom y selecciona un producto para ver sus detalles.",
      },
      sidepanel: {
        title: "Herramientas para el planograma",
        body: "Cada pestaña abre una herramienta junto al planograma: artículos sin surtido, resaltados, mezcla de espacio, muebles y CDT Studio.",
      },
      "open-studio": {
        title: "Abre CDT Studio",
        body: "CDT Studio es donde haces que los planogramas de tienda se parezcan a este planograma base. Lee cómo está dispuesto este planograma, qué marcas van juntas, en qué orden y con cuánto espacio, y lo convierte en el CDT del que se genera cada planograma de tienda.",
        instruction: "Haz clic en la pestaña CDT Studio.",
      },
      "studio-tree": {
        title: "El árbol es este planograma, por escrito",
        body: "Cada nodo es un grupo de productos tal como están en este planograma, en el orden en que están. Los planogramas de tienda siguen este árbol, así que una tienda mantiene los mismos grupos en el mismo orden incluso en una pared de otro tamaño.",
      },
      "studio-findings": {
        title: "Excepciones: donde la base rompe su propio patrón",
        body: "Una excepción es un lugar donde este planograma rompe su propia agrupación, como un producto dentro del bloque de otra marca. Si se deja así, se copia en cada planograma de tienda. Cada una se puede corregir, aceptar o descartar aquí.",
      },
      "studio-fix-blocking": {
        title: "Corregir bloqueo vertical",
        body: "Cuadra los bloques de marca para un bloqueo vertical limpio y muestra una vista previa del resultado, para que cada tienda tenga bloques verticales ordenados como estos en lugar de una escalera. No cambia nada hasta que finalices.",
      },
      "studio-finalize": {
        title: "Finalizar: que las tiendas sigan este planograma",
        body: "Al finalizar se guarda el CDT como una versión, junto con lo que el estudio midió aquí: el ancho, los frentes y la posición de cada bloque. Los planogramas de tienda se disponen entonces según este planograma en lugar de los valores por defecto de la categoría, y usan bloqueo vertical por defecto, u horizontal si el estudio lee esta pared como bloqueo horizontal. Después, Generate Store Planograms se abre con esta versión seleccionada. Hasta que finalices, usan bloqueo horizontal por defecto.",
      },
      "close-studio": {
        title: "Sal del estudio",
        body: "Cerrar sin finalizar descarta lo que hiciste en el estudio. Los planogramas de tienda no seguirán este planograma hasta que vuelvas y finalices.",
        instruction: "Haz clic en Cerrar.",
      },
      "discard-studio": {
        title: "Descarta lo que hiciste en el estudio",
        body: "El estudio pregunta antes de descartar cambios que no se finalizaron. En el ejercicio, descártalos.",
        instruction: "Haz clic en Descartar y cerrar.",
      },
      metrics: {
        title: "Qué tan bueno es el planograma",
        body: "Estas puntuaciones se actualizan mientras editas: retorno sobre el espacio, surtido básico, alineación de estantes, días de inventario y estética. Pasa el cursor sobre una puntuación para ver qué mide.",
      },
      "open-rules": {
        title: "Configura las reglas de los planogramas de tienda",
        body: "Generar siempre empieza por las reglas. Abrirlas no inicia nada.",
        instruction: "Haz clic en “Generate Store Planograms”.",
      },
      "open-advanced": {
        title: "Primero O, luego todas las reglas",
        body: "Las reglas se abren en O, que lee este planograma base y tus reglas y sugiere qué cambiar. Ajustes avanzados muestra todas las reglas.",
        instruction: "Haz clic en “Ajustes avanzados”.",
      },
      "rules-without-studio": {
        title: "Primero finaliza los CDT",
        body: "CDT Studio no se finalizó para este planograma, así que todavía no se pueden generar planogramas de tienda: se construyen con las reglas que envía Studio. El botón te lleva al estudio.",
      },
      "try-vertical": {
        title: "Prueba el bloqueo vertical",
        body: "Mira qué pasa cuando pides bloqueo vertical sin CDT finalizados.",
        instruction: "Cambia “Use vertical blocking mode?” a Yes.",
      },
      "stay-horizontal": {
        title: "Una generación vertical necesita CDT finalizados",
        body: "La generación queda desactivada hasta que finalices los CDT en el estudio o vuelvas a horizontal.",
        instruction: "Haz clic en Mantener horizontal.",
      },
      "rules-tabs": {
        title: "Las reglas, por tema",
        body: "General cubre muebles, surtido y merchandising. La pestaña Auto-Mudmap Engine planifica los bloques. Optimization Options define con qué rigor se mantiene cada regla.",
      },
      "rules-footer": {
        title: "Qué optimizar",
        body: "Elige el nivel de CDT en el que se planifican los bloques y si optimizar por ventas, margen o dispersión. Import y Export guardan un conjunto de reglas como archivo.",
      },
      "rules-generate": {
        title: "Inicia la generación",
        body: "Esto inicia un planograma por tienda y te lleva a Store Planograms, donde aparecen a medida que terminan. Está desactivado durante el ejercicio.",
      },
      "close-rules": {
        title: "Cierra las reglas",
        body: "Cancel deja todo como estaba.",
        instruction: "Haz clic en Cancel.",
      },
      done: {
        title: "Ese es todo el flujo",
        body: "Abre CDT Studio, finaliza el CDT para que las tiendas sigan este planograma, configura las reglas y genera. Puedes repetir este ejercicio cuando quieras desde Recorrido, arriba en esta página.",
      },
      "no-planogram": {
        title: "Primero necesitas un planograma",
        body: "El ejercicio se hace con uno de tus propios planogramas base y ninguno de tus flujos tiene uno todavía. Crea un flujo con New Flow en esta página y luego empieza el ejercicio desde Recorrido, arriba en su planograma base.",
      },
    },
  },
};
